<template>
  <v-container>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <v-card style="border: black 2px solid">
        <v-card-title class="headline mb-1">
          <span> ข้อมูลขอเสนอแผนตั้งงบประมาณประจำปี</span>
        </v-card-title>
        <v-container>
          <v-expand-transition>
            <v-card v-if="!Details_Cordi"
                    style="border: black 1px solid"
            >
              <v-row
                  justify="center"
                  class="d-flex justify-center">
                <v-col
                    cols="12"
                    md="12">
                  <v-card-title>
                    ตารางข้อมูลรายละเอียดเสนอแผน
                  </v-card-title>
                </v-col>
              </v-row>
              <v-list>
                <v-list-item>
                  <v-row class="d-flex justify-center">
                    <v-col
                        cols="12"
                        md="12"
                        class="d-flex justify-center"
                    >
                      <!-- <v-radio-group row v-model="YearSel" @change="ChooseYearFiscal"> -->
                      <v-radio-group row v-model="YearSel" @change="selProjFiscalYear">
                        <v-radio v-for="(yearMenu, idx) in FiscalYearMenuData" :key="idx"
                                 :label="'แผนประจำปี ' + yearMenu.yearth" :value="yearMenu.year">
                          <template v-slot:label>
                            <div>
                          <span>
                           แผนประจำปี {{ yearMenu.yearth }}
                          </span>
                              <v-chip :color="appColor" class="font-weight-bold" dark v-if="YearSel == yearMenu.year">
                                {{
                                  projectDataToTableDump.filter(projI => projI.Project_type == TypeProject && projI.FiscalYear == yearMenu.year).length
                                }}
                              </v-chip>
                            </div>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list>
              <v-divider></v-divider>
              <v-list>
                <v-list-item class="d-flex justify-center">
                  <v-radio-group row v-model="typeIsPlan" @change="ChooseTypeStatus">
                    <v-radio label="ทั้งหมด" value="all">
                      <template v-slot:label>
                        <div>
                          <span style="font-weight: bold">
                           ทั้งหมด
                          </span>
                          <v-chip :color="appColor" class="font-weight-bold" dark>
                            {{
                              projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel).length
                            }}
                          </v-chip>
                        </div>
                      </template>
                    </v-radio>
                    <v-radio label="งานในแผน" value="1">
                      <template v-slot:label>
                        <div>
                          <span style="font-weight: bold">
                           งานในแผน
                          </span>
                          <v-chip :color="appColor" class="font-weight-bold" dark>
                            {{
                              projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel && item.IsPlan == '1').length
                            }}
                          </v-chip>
                        </div>
                      </template>
                    </v-radio>
                    <v-radio label="งานนอกแผน" value="0">
                      <template v-slot:label>
                        <div>
                          <span style="font-weight: bold">
                           งานนอกแผน
                          </span>
                          <v-chip :color="appColor" class="font-weight-bold" dark>
                            {{
                              projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel && item.IsPlan == '0').length
                            }}
                          </v-chip>
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-list-item>
              </v-list>
              <v-divider></v-divider>
              <v-list>
                <template v-if="typeIsPlan == 'all'">
                  <v-list-item class="d-flex justify-center">
                  <v-radio-group row v-model="typeProjCat" @change="ChooseTypeStatus">
                    <v-radio label="ทั้งหมด" value="all">
                      <template v-slot:label>
                        <div>
                          <span style="font-weight: bold">
                           ทั้งหมด
                          </span>
                          <v-chip :color="appColor" class="font-weight-bold" dark>
                            {{
                              projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel).length
                            }}
                          </v-chip>
                        </div>
                      </template>
                    </v-radio>
                    <v-radio label="พัฒนาบุคลากร" value="1">
                      <template v-slot:label>
                        <div>
                          <span style="font-weight: bold">
                           พัฒนาบุคลากร
                          </span>
                          <v-chip :color="appColor" class="font-weight-bold" dark>
                            {{
                              projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel && item.Project_category == '1').length
                            }}
                          </v-chip>
                        </div>
                      </template>
                    </v-radio>
                    <v-radio label="โครงการอื่นๆ" value="2">
                      <template v-slot:label>
                        <div>
                          <span style="font-weight: bold">
                           โครงการอื่นๆ
                          </span>
                          <v-chip :color="appColor" class="font-weight-bold" dark>
                            {{
                              projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel && item.Project_category == '2').length
                            }}
                          </v-chip>
                        </div>
                      </template>
                    </v-radio>
                    <v-radio label="บริการวิชาการ" value="3">
                      <template v-slot:label>
                        <div>
                          <span style="font-weight: bold">
                           บริการวิชาการ
                          </span>
                          <v-chip :color="appColor" class="font-weight-bold" dark>
                            {{
                              projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel && item.Project_category == '3').length
                            }}
                          </v-chip>
                        </div>
                      </template>
                    </v-radio>
                    <v-radio label="วิจัย" value="4">
                      <template v-slot:label>
                        <div>
                          <span style="font-weight: bold">
                           วิจัย
                          </span>
                          <v-chip :color="appColor" class="font-weight-bold" dark>
                            {{
                              projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel && item.Project_category == '4').length
                            }}
                          </v-chip>
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-list-item>
                </template>
                <template v-else>
                  <v-list-item class="d-flex justify-center">
                    <v-radio-group row v-model="typeProjCat" @change="ChooseTypeStatus">
                      <v-radio label="ทั้งหมด" value="all">
                        <template v-slot:label>
                          <div>
                          <span style="font-weight: bold">
                           ทั้งหมด
                          </span>
                            <v-chip :color="appColor" class="font-weight-bold" dark>
                              {{
                                projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel && item.IsPlan == typeIsPlan).length
                              }}
                            </v-chip>
                          </div>
                        </template>
                      </v-radio>
                      <v-radio label="พัฒนาบุคลากร" value="1">
                        <template v-slot:label>
                          <div>
                          <span style="font-weight: bold">
                           พัฒนาบุคลากร
                          </span>
                            <v-chip :color="appColor" class="font-weight-bold" dark>
                              {{
                                projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel && item.IsPlan == typeIsPlan && item.Project_category == '1').length
                              }}
                            </v-chip>
                          </div>
                        </template>
                      </v-radio>
                      <v-radio label="โครงการอื่นๆ" value="2">
                        <template v-slot:label>
                          <div>
                          <span style="font-weight: bold">
                           โครงการอื่นๆ
                          </span>
                            <v-chip :color="appColor" class="font-weight-bold" dark>
                              {{
                                projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel && item.IsPlan == typeIsPlan && item.Project_category == '2').length
                              }}
                            </v-chip>
                          </div>
                        </template>
                      </v-radio>
                      <v-radio label="บริการวิชาการ" value="3">
                        <template v-slot:label>
                          <div>
                          <span style="font-weight: bold">
                           บริการวิชาการ
                          </span>
                            <v-chip :color="appColor" class="font-weight-bold" dark>
                              {{
                                projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel && item.IsPlan == typeIsPlan && item.Project_category == '3').length
                              }}
                            </v-chip>
                          </div>
                        </template>
                      </v-radio>
                      <v-radio label="วิจัย" value="4">
                        <template v-slot:label>
                          <div>
                          <span style="font-weight: bold">
                           วิจัย
                          </span>
                            <v-chip :color="appColor" class="font-weight-bold" dark>
                              {{
                                projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel && item.IsPlan == typeIsPlan && item.Project_category == '4').length
                              }}
                            </v-chip>
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-list-item>
                </template>
              </v-list>
              <v-divider></v-divider>
              <v-list>
                <v-list-item class="justify-center">
                  <v-radio-group class="font-weight-bold" v-model="sortStatus" row>
                    <v-radio label="แสดงทั้งหมด" value="1"></v-radio>
                    <v-radio label="เลือกแสดงตามสถานะ" value="2"></v-radio>
                  </v-radio-group>
                </v-list-item>
                <v-list-item v-if="sortStatus == '2'">
                  <v-row
                      justify="center"
                      class="justify-center">
                    <v-col
                        cols="12"
                        md="4"
                    >
                      <v-select
                          v-model="selStatus"
                          :items="StatusProject"
                          item-value="id"
                          item-text="status"
                      >
                        <template v-slot:item="{item}">
                          <h4 class="font-weight-bold">{{item.status}}
                            <span style="color: #364eff" v-if="typeProjCat != 'all' && typeIsPlan != 'all'">{{projectDataToTable.filter(itemProj => itemProj.Project_type == '1' && itemProj.FiscalYear == YearSel && itemProj.IsPlanStatus == item.id && itemProj.IsPlan == typeIsPlan && itemProj.Project_category == typeProjCat).length}}</span>
                            <span style="color: #364eff" v-else-if="typeProjCat == 'all' && typeIsPlan != 'all'">{{projectDataToTable.filter(itemProj => itemProj.Project_type == '1' && itemProj.FiscalYear == YearSel && itemProj.IsPlanStatus == item.id && itemProj.IsPlan == typeIsPlan).length}}</span>
                            <span style="color: #364eff" v-else-if="typeProjCat != 'all' && typeIsPlan == 'all'">{{projectDataToTable.filter(itemProj => itemProj.Project_type == '1' && itemProj.FiscalYear == YearSel && itemProj.IsPlanStatus == item.id && itemProj.Project_category == typeProjCat).length}}</span>
                            <span style="color: #364eff" v-else-if="typeProjCat == 'all' && typeIsPlan == 'all'">{{projectDataToTable.filter(itemProj => itemProj.Project_type == '1' && itemProj.FiscalYear == YearSel && itemProj.IsPlanStatus == item.id).length}}</span>
                            รายการ
                          </h4>
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                </v-list-item>

<!--                <v-list-item class="d-flex justify-center">
                  <template v-if="typeIsPlan == 'all'">
                    <template v-if="typeProjCat == 'all'">
                      <v-radio-group class="justify-center" row v-model="typeStatus2" @change="ChooseTypeStatus">
                      <v-radio label="ทั้งหมด" value="A">
                        <template v-slot:label>
                          <div>
                          <span style="font-weight: bold">
                           ทั้งหมด
                          </span>
                            <v-chip :color="appColor" class="font-weight-bold" dark>
                              {{
                                projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel).length
                              }}
                            </v-chip>
                          </div>
                        </template>
                      </v-radio>
                      <v-radio v-for="(staProject, idx) in StatusProject" :label="staProject.status"
                               :value="staProject.id" :key="idx" class="pa-1">
                        <template v-slot:label>
                          <div>
                          <span>
                           {{ staProject.status }}
                          </span>
                            <v-chip :color="staProject.color" class="font-weight-bold" dark>
                              {{
                                projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel && item.IsPlanStatus == staProject.id).length
                              }}
                            </v-chip>
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    </template>
                    <template v-else>
                      <v-radio-group class="justify-center" row v-model="typeStatus2" @change="ChooseTypeStatus">
                        <v-radio label="ทั้งหมด" value="A">
                          <template v-slot:label>
                            <div>
                          <span style="font-weight: bold">
                           ทั้งหมด
                          </span>
                              <v-chip :color="appColor" class="font-weight-bold" dark>
                                {{
                                  projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel && item.Project_category == typeProjCat).length
                                }}
                              </v-chip>
                            </div>
                          </template>
                        </v-radio>
                        <v-radio v-for="(staProject, idx) in StatusProject" :label="staProject.status"
                                 :value="staProject.id" :key="idx" class="pa-1">
                          <template v-slot:label>
                            <div>
                          <span style="font-weight: bold">
                           {{ staProject.status }}
                          </span>
                              <v-chip :color="staProject.color" class="font-weight-bold" dark>
                                {{
                                  projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel && item.IsPlanStatus == staProject.id && item.Project_category == typeProjCat).length
                                }}
                              </v-chip>
                            </div>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="typeProjCat == 'all'">
                    <v-radio-group class="justify-center" row v-model="typeStatus2" @change="ChooseTypeStatus">
                      <v-radio label="ทั้งหมด" value="A">
                        <template v-slot:label>
                          <div>
                          <span style="font-weight: bold">
                           ทั้งหมด
                          </span>
                            <v-chip :color="appColor" class="font-weight-bold" dark>
                              {{
                                projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel && item.IsPlan == typeIsPlan).length
                              }}
                            </v-chip>
                          </div>
                        </template>
                      </v-radio>
                      <v-radio v-for="(staProject, idx) in StatusProject" :label="staProject.status"
                               :value="staProject.id" :key="idx" class="pa-1">
                        <template v-slot:label>
                          <div>
                          <span style="font-weight: bold">
                           {{ staProject.status }}
                          </span>
                            <v-chip :color="staProject.color" class="font-weight-bold" dark>
                              {{
                                projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel && item.IsPlanStatus == staProject.id && item.IsPlan == typeIsPlan).length
                              }}
                            </v-chip>
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    </template>
                    <template v-else>
                      <v-radio-group class="justify-center" row v-model="typeStatus2" @change="ChooseTypeStatus">
                        <v-radio label="ทั้งหมด" value="A">
                          <template v-slot:label>
                            <div>
                          <span style="font-weight: bold">
                           ทั้งหมด
                          </span>
                              <v-chip :color="appColor" class="font-weight-bold" dark>
                                {{
                                  projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel && item.IsPlan == typeIsPlan && item.Project_category == typeProjCat).length
                                }}
                              </v-chip>
                            </div>
                          </template>
                        </v-radio>
                        <v-radio v-for="(staProject, idx) in StatusProject" :label="staProject.status"
                                 :value="staProject.id" :key="idx" class="pa-1">
                          <template v-slot:label>
                            <div>
                          <span style="font-weight: bold">
                           {{ staProject.status }}
                          </span>
                              <v-chip :color="staProject.color" class="font-weight-bold" dark>
                                {{
                                  projectDataToTableDump.filter(item => item.Project_type == TypeProject && item.FiscalYear == YearSel && item.IsPlanStatus == staProject.id && item.IsPlan == typeIsPlan && item.Project_category == typeProjCat).length
                                }}
                              </v-chip>
                            </div>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </template>
                  </template>
                </v-list-item>-->
              </v-list>
              <v-divider></v-divider>
              <v-list>
                <v-list-item class="d-flex justify-center">
                  <v-btn v-if="TypeProject == '1'" outlined color="green" class="darken-3" @click="OpenDialogReport">
                    Export ข้อมูลแผน
                  </v-btn>
                </v-list-item>
              </v-list>
              <v-list>
                <v-list-item>
                  <v-spacer></v-spacer>
                  <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="ค้นหาแผน"
                      single-line
                      hide-details
                  ></v-text-field>
                </v-list-item>
              </v-list>
              <v-row
                  justify="center"
                  class="justify-center">
                <v-col
                    cols="12"
                    md="12"
                >

                  <!--                        @click:row="GetData"-->
                  <v-data-table
                      :headers="courseHeaders"
                      :items="sortStatus == '1' ? projectDataToTable : projectDataToTable.filter(itemProj => itemProj.IsPlanStatus == selStatus)"
                      :search="search"
                      item-key="Project_code"
                      :single-expand="singleExpand"
                      :expanded.sync="expanded"
                      class="elevation-1"
                  >
                    <template v-slot:header.Project_code>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        รหัสแผน
                      </v-label>
                    </template>
                    <template v-slot:header.full_Name>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        งาน / กิจกรรม
                      </v-label>
                    </template>
                    <template v-slot:header.IsPlanStatus>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        สถานะ
                      </v-label>
                    </template>
                    <template v-slot:header.BudgetRequest>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        งบประมาณ
                      </v-label>
                    </template>
                    <template v-slot:header.BudgetArrove>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        อนุมัติวงเงิน
                      </v-label>
                    </template>
                    <template v-slot:header.MoneyDisburse>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        จำนวนเงินเบิกจ่าย
                      </v-label>
                    </template>
                    <template v-slot:item.full_Name="{item}">
                      <div v-html="item.full_Name"></div>
                    </template>
                    <template v-slot:item.BudgetRequest="{item}">
                      <span style="font-weight: bold;color: #ff6d81">{{ item.BudgetRequest | currency }}</span>
                    </template>
                    <template v-slot:item.BudgetArrove="{item}">
                      <span style="font-weight: bold;color: #ff6d81">{{ item.BudgetArrove | currency }}</span>
                    </template>
                    <template v-slot:item.MoneyDisburse="{item}">
                      <span style="font-weight: bold;color: #ff6d81">{{ item.MoneyDisburse | currency }}</span>
                    </template>
                    <template v-slot:item.IsPlanStatus="{item}">
                      <v-btn
                          x-large
                          v-if="item.IsPlanStatus == '0' && item.IsDataComplete == '1'"
                          outlined
                          color="#00C853"
                          style="transform: scale(0.8);"
                          @click="Project_proposal(item)"
                      >
                        เสนอแผน
                      </v-btn>
                      <v-chip
                          x-large
                          v-else-if="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0"
                          :color="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].color : ''"
                          style="transform: scale(0.8);color: white"
                      >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].status : ''
                              }}</span>
                      </v-chip>
                    </template>
                    <template v-slot:item.Project_Details="{ item }">
                      <v-btn
                          text
                          color="#FFB300"
                          @click="ShowDetail(item)"
                      >
                        รายละเอียด
                      </v-btn>
<!--                      <v-menu offset-y-->
<!--                              :value="item.Menu"-->
<!--                              :close-on-content-click="false"-->
<!--                              ref="menuRef"-->
<!--                              v-if="MeData[0].perid == '46792'"-->
<!--                      >-->
                      <v-menu offset-y
                              :value="item.Menu"
                              :close-on-content-click="false"
                              ref="menuRef"
                      >
                        <template v-slot:activator="{ on, attrs }" v-if="item.IsPlanStatus != '9'">
                          <v-btn
                              text
                              color="primary"
                              dark
                              v-bind="attrs"
                              v-on="on"
                          >
                            เมนู
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item style="cursor: pointer" v-if="item.IsPlanStatus == '0' && item.IsDataComplete == '1'">
                            <v-list-item-title text @click="Project_proposal(item)">
                              เสนอแผน
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item style="cursor: pointer" v-if="item.Status == '1' && item.IsPlanStatus == '7' && item.IsDataComplete == '1'">
                            <v-list-item-title @click="SuccessProject(item)">
                              <span style="color: #42b983;font-weight: bold">ปิดโครงการ</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item style="cursor: pointer" v-if="(item.IsPlanStatus == '2' || item.IsPlanStatus == '4' || item.IsPlanStatus == '5' || item.IsPlanStatus == '6' || item.IsPlanStatus == '7')">
                            <v-list-item-title
                                @click="remarksProject(item)">
                              <span style="color: #ff6d81;font-weight: bold">ยกเลิก</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item style="cursor: pointer">
<!--                            <v-list-item-title v-if="item.IsPlanStatus == '0' || item.IsPlanStatus == '4'" color="red" text
                                               @click="DelProject(item)">
                              ลบ
                            </v-list-item-title>-->
                            <v-list-item-title color="red" text @click="DelProject(item)">
                              <span style="color: red;font-weight: bold">ลบ</span>
                            </v-list-item-title>
                          </v-list-item>
                          <!--                          <v-list-item style="cursor: pointer">-->
                          <!--                            <v-list-item-title v-if="MeData[0].perid == '46792'" color="black" text-->
                          <!--                                               @click="DelProjectOwner(item)">ลบข้อมูล-->
                          <!--                            </v-list-item-title>-->
                          <!--                          </v-list-item>-->
                        </v-list>
                      </v-menu>
                      <v-btn v-if="item.IsPlanStatus == '9'" text color="brown"
                                @click="showRemarksCancelProj(item)">
                                เหตุผลการยกเลิก
                              </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card>
          </v-expand-transition>
          <v-card v-if="Details_Cordi"
                  elevation="10"
          >
            <v-list-item>
              <v-btn
                  outlined
                  color="#FF5722"
                  @click="BackMenu">
                ย้อนกลับ
              </v-btn>
            </v-list-item>
            <v-tabs
                v-model="tabMenu"
                fixed-tabs
                dark
                class="pa-6"
            >
              <v-tab key="tab1">
                <span style="font-weight: bold;font-size: 20px;padding: 10px">แผนตั้งงบ</span>
              </v-tab>
              <v-tab key="tab2">
                <span style="font-weight: bold;font-size: 20px;padding: 10px">ประวัติการแก้ไขแผนตั้งงบ</span>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabMenu">
              <v-tab-item
                  key="tab1"
              >
                <template>
                  <div>
                    <v-stepper
                        v-model="e1"
                        :vertical="vertical"
                        :alt-labels="altLabels"
                    >
                      <v-stepper-step editable step="1">
                        <span class="font-weight-bold">ข้อมูลเสนอแผน</span>
                      </v-stepper-step>
                      <v-stepper-content step="1">
                        <v-list-item three-line>
                          <v-list-item-content>
                            <v-list-item style="margin-top: 20px">
                              <div class="py-4">
                                <v-row>
                                  <v-col
                                      cols="12"
                                      md="6">
                                    <p class="font-weight-bold">หน่วยงาน:
                                      {{
                                        depart.filter(item => item.dep_id == objProject.Dep_Code).length > 0 ? depart.filter(item => item.dep_id == objProject.Dep_Code)[0].dep_name : '-'
                                      }}</p>
                                    <p class="font-weight-bold">แผนประจำปี: {{
                                        parseInt(objProject.FiscalYear) + 543
                                      }}</p>
                                    <p class="font-weight-bold" v-if="objProject.Project_type == '2'">ประเภททำรายการ:
                                      {{
                                        objProject.IsProcess == '2' ? 'เดินทางไปราชการ (ในวิชาชีพ)' : objProject.IsProcess == '1' ? 'เดินทางไปราชการ (นอกวิชาชีพ)' : 'เดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา)'
                                      }}</p>
                                    <p class="font-weight-bold">หมวดโครงการ:
                                      {{
                                        objProject.Project_category == '1' ? 'พัฒนาบุคลากร' : objProject.Project_category == '2' ? 'โครงการอื่นๆ' : objProject.Project_category == '3' ? 'บริการวิชาการ' : 'วิจัย'
                                      }}</p>
                                    <p class="font-weight-bold">ประเภทแผน: {{
                                        objProject.IsPlan == '1' ? 'ในแผน' : 'นอกแผน'
                                      }}</p>
                                    <p class="font-weight-bold" v-if="episode == '1'">ระยะเวลาที่คาดว่าจะจัด:
                                      {{
                                        'ต.ค. ' + (parseInt(FiscalYear) + 543 - 1) + '- ธ.ค. ' + (parseInt(FiscalYear) + 543 - 1)
                                      }}</p>
                                    <p class="font-weight-bold" v-else-if="episode == '2'">
                                      ระยะเวลาที่คาดว่าจะจัด:
                                      {{
                                        'ม.ค. ' + (parseInt(FiscalYear) + 543) + '- มี.ค. ' + (parseInt(FiscalYear) + 543)
                                      }}</p>
                                    <p class="font-weight-bold" v-else-if="episode == '3'">
                                      ระยะเวลาที่คาดว่าจะจัด:
                                      {{
                                        'เม.ย. ' + (parseInt(FiscalYear) + 543) + '- มิ.ย. ' + (parseInt(FiscalYear) + 543)
                                      }}</p>
                                    <p class="font-weight-bold" v-else-if="episode == '4'">
                                      ระยะเวลาที่คาดว่าจะจัด:
                                      {{
                                        'ก.ค. ' + (parseInt(FiscalYear) + 543) + '- ก.ย. ' + (parseInt(FiscalYear) + 543)
                                      }}</p>
                                    <p class="font-weight-bold" v-else-if="episode == '9'">
                                      ระยะเวลาที่คาดว่าจะจัด:
                                      {{
                                        'ตลอดปีงบประมาณ ' + (parseInt(FiscalYear) + 543)
                                      }}</p>
                                    <p class="font-weight-bold">รหัสแผน: {{ objProject.Project_code }}</p>
                                    <p class="font-weight-bold">ชื่อ งาน / กิจกรรม: {{ objProject.Project_name }}</p>
                                    <p class="font-weight-bold">ประเภทแผน:
                                      {{
                                        projectGroup.filter(item => item.Project_group == objProject.Project_group).length > 0 ? projectGroup.filter(item => item.Project_group == objProject.Project_group)[0].Project_group_des : '-'
                                      }}</p>
                                    <p class="font-weight-bold">หลักสูตร:
                                      {{
                                        courseData.filter(item => item.Course_code == objProject.Course_code).length > 0 ? courseData.filter(item => item.Course_code == objProject.Course_code)[0].Course_name : '-'
                                      }}</p>
                                    <p class="font-weight-bold">สาขาประเภทหลักสูตร:
                                      {{
                                        courseData.filter(item => item.Course_code == objProject.Course_code).length > 0 ? courseData.filter(item => item.Course_code == objProject.Course_code)[0].Course_type_des : '-'
                                      }}</p>
                                    <p class="font-weight-bold">ระยะเวลา:
                                      {{
                                        courseData.filter(item => item.Course_code == objProject.Course_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == objProject.Course_code)[0].Period_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == objProject.Course_code)[0].Period_code)[0].name : '-' : '-'
                                      }}</p>
                                  </v-col>
                                  <v-col
                                      cols="12"
                                      md="6">
                                    <p class="font-weight-bold">จำนวน ช.ม.: {{ objProject.CalHourse }}</p>
                                    <p class="font-weight-bold">จำนวน เครดิต: {{ objProject.CalCredit }}</p>
                                    <p class="font-weight-bold">งบประมาณที่ขอ: {{ objProject.BudgetRequest }}</p>
                                    <p class="font-weight-bold">งาน / กิจกรรม ถูกจัดขึ้น: {{
                                        PLACESelete.filter(item => item.id == objProject.PLACE).length > 0 ? PLACESelete.filter(item => item.id == objProject.PLACE)[0].detail : '-'
                                      }}</p>
                                    <p class="font-weight-bold" v-if="objProject.PLACE == '2'">จังหวัด: {{
                                        provinces_Data.filter(item => item.code == objProject.Province_id).length > 0 ? provinces_Data.filter(item => item.code == objProject.Province_id)[0].name_th : '-'
                                      }}</p>
                                    <p class="font-weight-bold" v-else-if="objProject.PLACE == '3'">ประเทศ: {{
                                        countryData.filter(item => item.ct_code == objProject.Country_id).length > 0 ? countryData.filter(item => item.ct_code == objProject.Country_id)[0].ct_nameTHA : '-'
                                      }}</p>
                                    <p class="font-weight-bold">จัดโดย:
                                      {{
                                        WorkByData.filter(item => item.id == objProject.WorkBy).length > 0 ? WorkByData.filter(item => item.id == objProject.WorkBy)[0].detail : '-'
                                      }}</p>
                                    <p class="font-weight-bold">ชื่อผู้จัด: {{ objProject.WorkByName }}</p>
                                    <p class="font-weight-bold">เบอร์โทรติดต่อผู้กรอกข้อมูล: {{ objProject.WorkByPhone }}</p>
                                    <p class="font-weight-bold">สถานที่จัด: {{ objProject.Location }}</p>
                                    <p class="font-weight-bold">กลุ่มเป้าหมาย: {{ objProject.TargetGroup }}</p>
                                    <p class="font-weight-bold">วัตถุประสงค์: {{ objProject.Objective }}</p>
                                    <p class="font-weight-bold">รายละเอียดประกอบ (เพิ่มเติม ถ้ามี):
                                      {{ objProject.Remarks }}</p>
                                    <p class="font-weight-bold">Competency,Core Value,Strategic Objective:
                                      <v-btn text color="primary" @click="showCompetency(objProject)">คลิก!!</v-btn>
                                    </p>
                                    <p class="font-weight-bold">ไฟล์เอกสารประกอบ:
                                      <v-btn text color="primary" @click="showFile()">คลิก!!</v-btn>
                                    </p>
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <p class="mt-8" style="font-weight: bold">วันที่บันทึกข้อมูลแผน:
                                  {{ objProject.Create_Time | dateToThai2 }}</p>
                                <p style="font-weight: bold">สถานะแผน:
                                  <v-chip
                                      v-if="StatusProject.filter(staItem => staItem.id == objProject.IsPlanStatus).length > 0"
                                      :color="StatusProject.filter(staItem => staItem.id == objProject.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == objProject.IsPlanStatus)[0].color : ''"
                                      style="transform: scale(0.8);color: white"
                                  >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == objProject.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == objProject.IsPlanStatus)[0].status : ''
                              }}</span>
                                  </v-chip>
                                </p>
                                <template v-if="parseInt(objProject.IsPlanStatus) >= 6 && parseInt(objProject.IsPlanStatus) <= 9">
                                  <hr class="mb-2 mt-2"/>
                                  <span style="font-size: 16px;color: green;font-weight: bold;margin-top: 30px">
                                อนุมัติวงเงิน : {{ objProject.BudgetArrove | currency }} บาท
                              </span>
                                </template>
                                <template v-if="parseInt(objProject.IsPlanStatus) >= 6 && parseInt(objProject.IsPlanStatus) <= 9">
                                  <hr class="mb-2 mt-2"/>
                                  <span style="font-size: 16px;color: green;font-weight: bold;margin-top: 30px">
                                จำนวนเงินเบิกจ่าย : {{ objProject.MoneyDisburse | currency }} บาท
                              </span>
                              <v-btn text color="primary" @click="showExpenseReal(objProject)">(ดูรายละเอียด)</v-btn>
                                </template>
                                <v-divider></v-divider>
                              </div>
                            </v-list-item>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="d-flex justify-end">
                        </v-list-item>
                      </v-stepper-content>
                      <v-stepper-step editable step="2">
                        <span class="font-weight-bold">ผลการพิจารณา</span>
                      </v-stepper-step>
                      <v-stepper-content step="2">
                        <template v-if="RecordDataDump.length > 0">
                          <v-list-item class="justify-center">
                            <v-row justify="center">
                              <v-col
                                  cols="12"
                                  md="12">
                                <span style="font-weight: bold">ประวัติการพิจารณาเสนอแผน</span>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item class="justify-center">
                            <v-row justify="center">
                              <v-col
                                  cols="12"
                                  md="12">
                                <v-list-item>
                                  <v-expansion-panels popout>
                                    <v-expansion-panel
                                        v-for="(item,i) in RecordDataDump"
                                        :key="i"
                                    >
                                      <v-expansion-panel-header>
                                        ประวัติการพิจารณาเสนอแผน
                                        วันที่พิจารณา
                                        <span style="color: #364eff;margin-left: 15px">{{
                                            item.Date_Approve | DateToThai
                                          }}</span>
                                        สถานะ :
                                        <v-chip
                                            v-if="StatusProject.filter(staItem => staItem.id == item.Status).length > 0"
                                            :color="StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].color : ''"
                                            style="transform: scale(0.8);color: white"
                                            class="d-flex justify-center"
                                        >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].status : ''
                              }}</span>
                                        </v-chip>
                                      </v-expansion-panel-header>
                                      <v-expansion-panel-content>
                                        <p>
                                          เหตุผล : {{ item.Remark }}
                                        </p>
                                        <div v-for="(file,idx) in item.files" v-bind:key="idx" style="color: #ff6d81">
                                          ไฟล์ประกอบ :
                                          <v-btn text @click="ShowData(Openfile + file.File_path)">{{ file.File_name }}
                                          </v-btn>
                                        </div>
                                      </v-expansion-panel-content>
                                    </v-expansion-panel>
                                  </v-expansion-panels>
                                </v-list-item>
                              </v-col>
                            </v-row>
                          </v-list-item>
                        </template>
                        <template v-else>
                          <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                            ไม่พบข้อมูลผลการพิจารณาแผน !!</p>
                        </template>
                      </v-stepper-content>
                    </v-stepper>
                  </div>
                </template>
              </v-tab-item>
              <v-tab-item
                  key="tab2"
              >
                <template v-if="LogProject.length > 0">
                  <v-timeline
                      dense
                  >
                    <v-timeline-item
                        v-for="(logProject, i) in LogProject"
                        :key="i"
                        color="cyan"
                        small
                    >
                      <template v-slot:opposite>
        <span
            class="headline font-weight-bold cyan--text"
        >{{ logProject.Create_Time | dateToThai2 }}</span>
                      </template>
                      <div class="py-4">
                        <h2 :class="`headline font-weight-light mb-4 cyan--text`">
                          {{ logProject.Create_Time | dateToThai2 }}
                        </h2>
                        <v-chip
                            v-if="StatusProject.filter(staItem => staItem.id == logProject.IsPlanStatus).length > 0"
                            :color="StatusProject.filter(staItem => staItem.id == logProject.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == logProject.IsPlanStatus)[0].color : ''"
                            style="transform: scale(0.8);color: white"
                        >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == logProject.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == logProject.IsPlanStatus)[0].status : ''
                              }}</span>
                        </v-chip>
                        <v-row>
                          <v-col
                              cols="12"
                              md="6">
                            <p class="font-weight-bold">หน่วยงาน:
                              {{
                                depart.filter(item => item.dep_id == logProject.Dep_Code).length > 0 ? depart.filter(item => item.dep_id == logProject.Dep_Code)[0].dep_name : '-'
                              }}</p>
                            <p class="font-weight-bold">แผนประจำปี: {{ parseInt(logProject.FiscalYear) + 543 }}</p>
                            <p class="font-weight-bold" v-if="logProject.Project_type == '2'">ประเภททำรายการ:
                              {{
                                logProject.IsProcess == '2' ? 'เดินทางไปราชการ (ในวิชาชีพ)' : logProject.IsProcess == '1' ? 'เดินทางไปราชการ (นอกวิชาชีพ)' : 'เดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา)'
                              }}</p>
                            <p class="font-weight-bold">หมวดโครงการ:
                              {{
                                logProject.Project_category == '1' ? 'พัฒนาบุคลากร' : logProject.Project_category == '2' ? 'โครงการอื่นๆ' : logProject.Project_category == '3' ? 'บริการวิชาการ' : 'วิจัย'
                              }}</p>
                            <p class="font-weight-bold">ประเภทแผน: {{
                                logProject.IsPlan == '1' ? 'ในแผน' : 'นอกแผน'
                              }}</p>
                            <p class="font-weight-bold" v-if="episode == '1'">ระยะเวลาที่คาดว่าจะจัด:
                              {{
                                'ต.ค. ' + (parseInt(FiscalYear) + 543 - 1) + '- ธ.ค. ' + (parseInt(FiscalYear) + 543 - 1)
                              }}</p>
                            <p class="font-weight-bold" v-else-if="episode == '2'">ระยะเวลาที่คาดว่าจะจัด:
                              {{
                                'ม.ค. ' + (parseInt(FiscalYear) + 543) + '- มี.ค. ' + (parseInt(FiscalYear) + 543)
                              }}</p>
                            <p class="font-weight-bold" v-else-if="episode == '3'">ระยะเวลาที่คาดว่าจะจัด:
                              {{
                                'เม.ย. ' + (parseInt(FiscalYear) + 543) + '- มิ.ย. ' + (parseInt(FiscalYear) + 543)
                              }}</p>
                            <p class="font-weight-bold" v-else-if="episode == '4'">ระยะเวลาที่คาดว่าจะจัด:
                              {{
                                'ก.ค. ' + (parseInt(FiscalYear) + 543) + '- ก.ย. ' + (parseInt(FiscalYear) + 543)
                              }}</p>
                            <p class="font-weight-bold" v-else-if="episode == '9'">ระยะเวลาที่คาดว่าจะจัด:
                              {{
                                'ตลอดปีงบประมาณ ' + (parseInt(FiscalYear) + 543)
                              }}</p>
                            <p class="font-weight-bold">รหัสแผน: {{ logProject.Project_code }}</p>
                            <p class="font-weight-bold">ชื่อ งาน / กิจกรรม: {{ logProject.Project_name }}</p>
                            <p class="font-weight-bold">ประเภทแผน: {{
                                projectGroup.filter(item => item.Project_group == logProject.Project_group).length > 0 ? projectGroup.filter(item => item.Project_group == logProject.Project_group)[0].Project_group_des : '-'
                              }}
                            </p>
                            <p class="font-weight-bold">หลักสูตร:
                              {{
                                courseData.filter(item => item.Course_code == logProject.Course_code).length > 0 ? courseData.filter(item => item.Course_code == logProject.Course_code)[0].Course_name : '-'
                              }}</p>
                            <p class="font-weight-bold">สาขาประเภทหลักสูตร:
                              {{
                                courseData.filter(item => item.Course_code == logProject.Course_code).length > 0 ? courseData.filter(item => item.Course_code == logProject.Course_code)[0].Course_type_des : '-'
                              }}</p>
                            <p class="font-weight-bold">ระยะเวลา:
                              {{
                                courseData.filter(item => item.Course_code == logProject.Course_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == logProject.Course_code)[0].Period_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == logProject.Course_code)[0].Period_code)[0].name : '-' : '-'
                              }}</p>
                          </v-col>
                          <v-col
                              cols="12"
                              md="6">
                            <p class="font-weight-bold">จำนวน ช.ม.: {{ logProject.CalHourse }}</p>
                            <p class="font-weight-bold">จำนวน เครดิต: {{ logProject.CalCredit }}</p>
                            <p class="font-weight-bold">งบประมาณที่ขอ: {{ logProject.BudgetRequest }}</p>
                            <p class="font-weight-bold">จัดโดย:
                              {{
                                WorkByData.filter(item => item.id == logProject.WorkBy).length > 0 ? WorkByData.filter(item => item.id == logProject.WorkBy)[0].detail : '-'
                              }}</p>
                            <p class="font-weight-bold">ชื่อผู้จัด: {{ logProject.WorkByName }}</p>
                            <p class="font-weight-bold">เบอร์โทรติดต่อผู้กรอกข้อมูล: {{ logProject.WorkByPhone }}</p>
                            <p class="font-weight-bold">สถานที่จัด: {{ logProject.Location }}</p>
                            <p class="font-weight-bold">กลุ่มเป้าหมาย: {{ logProject.TargetGroup }}</p>
                            <p class="font-weight-bold">วัตถุประสงค์: {{ logProject.Objective }}</p>
                            <p class="font-weight-bold">รายละเอียดประกอบ (เพิ่มเติม): {{ logProject.Remarks }}</p>
                            <p class="font-weight-bold">Competency,Core Value,Strategic Objective:
                              <v-btn text color="primary" @click="showLogCompetency(logProject)">คลิก!!</v-btn>
                            </p>
                            <p class="font-weight-bold">ไฟล์เอกสารประกอบ:
                              <v-btn text color="primary" @click="showLogFile(logProject)">คลิก!!</v-btn>
                            </p>
                            <p class="font-weight-bold">แก้ไขโดย: {{
                                staffData.filter(item => item.perid == logProject.Create_By).length > 0 ? staffData.filter(item => item.perid == logProject.Create_By)[0].full_Name + '(' + staffData.filter(item => item.perid == logProject.Create_By)[0].perid + ') ' + staffData.filter(item => item.perid == logProject.Create_By)[0].dep_name : '-'
                              }} {{ logProject.Edit_type == '0' ? '(user)' : '(Admin)' }}</p>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                      </div>
                    </v-timeline-item>
                  </v-timeline>
                </template>
                <template v-else>
                  <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                    ไม่พบข้อมูลประวัติการแก้ไขข้อมูลเสนอแผนตั้งงบ</p>
                </template>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-container>
      </v-card>
      <template>
        <v-dialog v-model="dialogProposal" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">ยืนยันการทำรายการ</v-card-title>
            <v-card-text>ต้องการยื่นเสนอแผนใช่หรือไม่ ?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialogProposal = false">ยกเลิก</v-btn>
              <v-btn color="green darken-1" text @click="proposal_To_Db">ตกลง</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogDetail"
            max-width="800"
        >
          <v-card v-if="itemToShow != null">
            <v-card-title class="headline"><span style="color: #42b983;font-weight: bold">{{
                itemToShow.DelvDes
              }}</span>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col
                    cols="12"
                    md="12">
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">ชื่อย่อ:</span> {{ itemToShow.DelvShort }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">ชื่อ Eng:</span> {{ itemToShow.DelvEng }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">คำอธิบาย:</span> {{ itemToShow.DelvRm }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">PSU:</span> {{ itemToShow.PSU }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black" v-if="itemToShow.DelvGroup == 'A'">
                    <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะหลัก
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'B'">
                    <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะด้านบริหาร
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'C'">
                    <span style="color: #364eff">กรุ๊ป:</span> จิตสํานึกด้านความเสียงและความปลอดภัย
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'D'">
                    <span style="color: #364eff">กรุ๊ป:</span> กลยุทธ์
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">คณะ/หน่วยงาน:</span> {{ itemToShow.dep_name }}
                  </p>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  text
                  @click="dialogDetail = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogTemplate"
            max-width="800"
        >
          <v-card>
            <v-card-title>ฟอร์ฺมตัวอย่าง</v-card-title>
            <v-card-text>
              <div v-html="editorData"></div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  text
                  @click="dialogTemplate = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogLecturerDetail"
            max-width="800"
        >
          <v-card>
            <v-card-title class="headline"><span style="color: #42b983;font-weight: bold">รายละเอียดการเป็นวิทยากร/คณะกรรมการ/นำเสนอผลงาน</span>
            </v-card-title>
            <v-card-text>
              <v-data-table :items="LecturerDetail" :headers="headerLecturer" class="elevation-2"
                            show-expand
                            style="width: 100%">
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <div v-for="(file, idx) in item.files" v-bind:key="idx">
                      <v-btn color="primary" text @click="ShowData(Openfile + file.File_path)">ไฟล์ : {{
                          file.File_name
                        }}
                      </v-btn>
                    </div>
                  </td>
                </template>
                <template v-slot:item.date_start="{item}">
                  <span>
                    {{ item.date_start | DateToThai }}
                  </span>
                </template>
                <template v-slot:item.date_end="{item}">
                  <span>
                    {{ item.date_end | DateToThai }}
                  </span>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  text
                  @click="dialogLecturerDetail = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <v-dialog
          v-model="dialogLoading"
          persistent
          width="300"
      >
        <v-card
            :color="appColor"
            dark
        >
          <v-card-text>
            Loading.....
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <template>
        <v-dialog
            v-model="dialogCompetency"
            max-width="800"
        >
          <v-card>
            <v-card-title>
              Competency,Core Value,Strategic Objective
            </v-card-title>
            <v-card-text>
              <template v-if="CompetencyToShow.length > 0">
                <v-treeview :activatable="true" :items="CompetencyToShow">
                  <template v-slot:prepend="{ item, open }">
                    <v-icon v-if="!item.file" color="blue lighten-2">
                      {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                    </v-icon>
                    <v-icon v-else>
                      {{ files[item.file] }}
                    </v-icon>
                  </template>
                  <template v-slot:label="{ item, active }">
                    <div v-if="isMobile" style="cursor: pointer">
                                                <span style="font-size: 12px;color: black" v-if="!active">
                                                    {{ item.name }}
                                                </span>
                      <span style="font-size: 12px;color: #364eff;font-weight: bold"
                            v-else>
                                                    {{ item.name }}
                                                </span>
                    </div>
                    <div v-else style="cursor: pointer">
                                                <span style="color:black;" v-if="!active">
                                                    {{ item.name }}
                                                </span>
                      <span style="color: #364eff;font-weight: bold" v-else>
                                                    {{ item.name }}
                                                </span>
                    </div>
                  </template>
                </v-treeview>
              </template>
              <template v-else>
                <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">ไม่พบข้อมูล
                  Competency,Core Value,Strategic Objective</p>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  outlined
                  @click="dialogCompetency = false"
              >
                <span style="font-size: 24px;font-weight: bold">ปิด</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogFile"
            max-width="800"
        >
          <v-card>
            <v-card-title>
              ไฟล์เอกสารประกอบ
            </v-card-title>
            <v-card-text>
              <template v-if="FileProject.length > 0">
                <v-container fluid>
                  <v-row>
                    <v-col
                        v-for="(file_i, index) in FileProject"
                        :key="index"
                        class="d-flex child-flex"
                        cols="12"
                        md="4"
                    >
                      <v-card flat tile>
                        <v-img
                            v-if="file_i.type == 'image'"
                            :src="file_i.src"
                            :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                            aspect-ratio="1"
                            class="grey lighten-2"
                        >
                          <template
                              v-slot:placeholder>
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                              <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-img
                            v-if="file_i.type == 'pdf'"
                            src="../../assets/Image/pdf.png"
                            :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                            aspect-ratio="1"
                            class="grey lighten-2"
                        >
                          <template
                              v-slot:placeholder>
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                              <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-card-text>
                                                                                                  <span
                                                                                                      style="font-weight: bold;color: black">
                                                                                                      {{ file_i.name }}
                                                                                                  </span>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn text
                                 @click="ShowData(file_i.src)">
                                                                                                      <span
                                                                                                          style="color: indigo;font-weight: bold">
                                                                                                          เรียกดู
                                                                                                      </span>
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <template v-else>
                <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                  ไม่พบข้อมูลไฟล์เอกสารประกอบ</p>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  outlined
                  @click="dialogFile = false"
              >
                <span style="font-size: 24px;font-weight: bold">ปิด</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogFileLog"
            max-width="800"
        >
          <v-card>
            <v-card-title>
              ไฟล์เอกสารประกอบ
            </v-card-title>
            <v-card-text>
              <template v-if="LogFileProject.length > 0">
                <v-container fluid>
                  <v-row>
                    <v-col
                        v-for="(file_i, index) in LogFileProject"
                        :key="index"
                        class="d-flex child-flex"
                        cols="12"
                        md="4"
                    >
                      <v-card flat tile>
                        <v-img
                            v-if="file_i.type == 'image'"
                            :src="file_i.src"
                            :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                            aspect-ratio="1"
                            class="grey lighten-2"
                        >
                          <template
                              v-slot:placeholder>
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                              <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-img
                            v-if="file_i.type == 'pdf'"
                            src="../../assets/Image/pdf.png"
                            :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                            aspect-ratio="1"
                            class="grey lighten-2"
                        >
                          <template
                              v-slot:placeholder>
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                              <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-card-text>
                                                                                                  <span
                                                                                                      style="font-weight: bold;color: black">
                                                                                                      {{ file_i.name }}
                                                                                                  </span>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn text
                                 @click="ShowData(file_i.src)">
                                                                                                      <span
                                                                                                          style="color: indigo;font-weight: bold">
                                                                                                          เรียกดู
                                                                                                      </span>
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <template v-else>
                <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                  ไม่พบข้อมูลไฟล์เอกสารประกอบ</p>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  outlined
                  @click="dialogFileLog = false"
              >
                <span style="font-size: 24px;font-weight: bold">ปิด</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <v-dialog
        v-model="dialogShowExpenseReal"
        max-width="1000"
        persistent>
        <v-card>
          <v-card-title class="font-weight-bold">
            <span>รายละเอียดการเบิกจ่าย : {{ Project_name }}</span>
          </v-card-title>
          <v-card-text>
            <template v-if="expenseRealHistoryData.length > 0">
              <v-list-item>
                <div class="d-flex flex-column justify-stretch" style="width: 100%">
                  <v-data-table
                      :headers="expenseRealHistoryHeader"
                      :items="expenseRealHistoryData"
                      class="elevation-1"
                  >
                    <template v-slot:header.Item>
                      <span style="font-weight: bold">ชื่อรายการ</span>
                    </template>
                    <template v-slot:header.Mon_total>
                      <span style="font-weight: bold">จำนวนเงิน</span>
                    </template>
                    <template v-slot:item.Mon_total="props">
                      <p class="mt-4" style="font-weight: bold">{{ props.item.Mon_total | currency }}</p>
                    </template>
                    <template v-slot:item.action="{ item }">
                      <td>
                        <v-btn
                            color="primary"
                            text
                            @click="showHistoryExpenseReal(item)"
                        >ดูรายละเอียด</v-btn>
                      </td>
                    </template>
                    <template
                        v-slot:footer
                    >
                      <template v-if="expenseRealHistoryData > 0">
                      </template>
                    </template>
                  </v-data-table>
                </div>
              </v-list-item>
            </template>
            <template v-else>
              <p style="font-size: 20px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px;width: 100%">
                ไม่พบข้อมูลรายละเอียดค่าใช้จ่าย</p>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                x-large
                color="red"
                dark
                @click="dialogShowExpenseReal = false"
            >Close
            </v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogShowHistoryExpenseReal"
        max-width="1000"
        persistent>
      <v-card>
        <v-card-title class="font-weight-bold" v-if="groupExpenseRealObj != null">
          <span>รายละเอียดการเบิกจ่าย : {{ groupExpenseRealObj.Item }}</span>
        </v-card-title>
        <v-card-text>
          <template v-if="expenseDetailRealHistoryData.length > 0">
            <v-list-item>
              <div class="d-flex flex-column justify-stretch" style="width: 100%">
                <v-data-table
                    :headers="expenseDetailRealHistoryHeader"
                    :items="expenseDetailRealHistoryData"
                    class="elevation-1"
                >
                  <template v-slot:header.Expense_des>
                    <span style="font-weight: bold">ชื่อรายการ</span>
                  </template>
                  <template v-slot:header.Mon_debit>
                    <span style="font-weight: bold">จำนวนเงิน</span>
                  </template>
                  <template v-slot:header.Monthly>
                    <span style="font-weight: bold">เดือนที่ทำรายการ</span>
                  </template>
                  <template v-slot:item.Mon_debit="props">
                    <p class="mt-4" style="font-weight: bold">{{ props.item.Mon_debit | currency }}</p>
                  </template>
                  <template v-slot:item.Monthly="{ item }">
                    <p class="mt-4" style="font-weight: bold">{{ item.Monthly | monthToThai }}</p>
                  </template>
                  <template
                      v-slot:footer
                  >
                    <template v-if="expenseDetailRealHistoryData > 0">
                    </template>
                  </template>
                </v-data-table>
              </div>
            </v-list-item>
          </template>
          <template v-else>
            <p style="font-size: 20px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px;width: 100%">
              ไม่พบข้อมูลรายละเอียดค่าใช้จ่าย</p>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              x-large
              color="red"
              dark
              @click="dialogShowHistoryExpenseReal = false"
          >Close
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogCancelOrCloseProject"
        max-width="600px"
    >
      <v-card v-if="ProjectObj != null">
        <v-card-title class="font-weight-bold">
          <span>กรุณาระบุเหตุผลยกเลิกการจัด โครงการ : {{ProjectObj.Project_name}} ({{ ProjectObj.Project_code }})</span>
        </v-card-title>
        <v-card-text>
          <v-textarea
              v-model="remarksCloseProject"
              label="เหตุผลการยกเลิกการจัดโครงการ"
              :error-messages="remarksCloseProject == '' ? 'เหตุผล ห้ามว่าง' : ''"
              :error="remarksCloseProject == ''"
              outlined
              required
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              @click="CancelProject(ProjectObj)"
          >บันทึก</v-btn>
          <v-btn
              color="red"
              @click="dialogCancelOrCloseProject = false"
          >ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogShowCencelRemarks"
        max-width="600"
        persistent
        >
        <v-card>
          <v-card-title class="font-weight-bold">
            <span>กรุณากรอกเหตุผลการยกเลิกแผน</span>
          </v-card-title>
          <v-card-text>
            <v-textarea v-model="RemarksCancelProj" outlined label="เหตุผลการยกเลิกแผน" rows="5"></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="red" @click="dialogShowCencelRemarks = false">ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <template>
        <v-dialog v-model="dialogExportPlanProj" max-width="800">
          <v-card>
            <v-card-title>
              <span style="font-width: bold;">เลือกรายละเอียดข้อมูลก่อนทำรายการ Export ข้อมูลแผนประจำปี {{
                parseInt(YearSel) + 543
                }}</span>
            </v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item>
                  <v-radio-group v-model="exportType" row>
                    <v-radio class="font-weight-bold" label="พัฒนาบุคลากร" value="1"></v-radio>
                    <v-radio class="font-weight-bold" label="โครงการอื่น ๆ" value="2"></v-radio>
                    <v-radio class="font-weight-bold" label="บริการวิชาการ" value="3"></v-radio>
                    <v-radio class="font-weight-bold" label="วิจัย" value="4"></v-radio>
                  </v-radio-group>
                </v-list-item>
                <v-list-item>
                  <v-radio-group v-model="exportType2" row>
                    <v-radio class="font-weight-bold" label="โครงการ" value="1"></v-radio>
                  </v-radio-group>
                </v-list-item>
                <v-list-item>
                  <v-radio-group v-model="exportType4" row>
                    <v-radio class="font-weight-bold" label="ทั้งหมด" value="1"></v-radio>
                    <v-radio class="font-weight-bold" label="เฉพาะที่อนุมัติ" value="0"></v-radio>
                    <v-radio class="font-weight-bold" label="เลือกเฉพาะ งานคลังอนุมัติวงเงิน, เบิกจ่ายเสร็จสิ้น, ปิดโครงการ" value="2"></v-radio>
                  </v-radio-group>
                </v-list-item>
                <v-list-item v-if="exportType4 != '1' && exportType4 != '' && exportType4 != null">
                  <v-radio-group v-model="exportType3" row>
                    <v-radio class="font-weight-bold" label="ทั้งหมด" value="9"></v-radio>
                    <v-radio class="font-weight-bold" label="มีรายการเบิกจ่าย" value="1"></v-radio>
                    <v-radio class="font-weight-bold" label="ไม่มีรายการเบิกจ่าย" value="0"></v-radio>
                  </v-radio-group>
                </v-list-item>
                <v-list-item>
                    <v-autocomplete
                    v-model="exportDepGroup"
                    :items="[{ dep_group_id: 'all', dep_group_name: 'ทั้งหมด' }, ...groupDepart]"
                    item-text="dep_group_name"
                    item-value="dep_group_id"
                    label="เลือกกลุ่มหน่วยงาน"
                    clearable
                    ></v-autocomplete>
                </v-list-item>
                <v-list-item class="d-flex justify-center">
                  <download-excel class="btn btn-default" :data="json_data" :fields="json_fields"
                    worksheet="แผนทั้งหมดภายในปี"
                    :name="'ข้อมูลเสนอแผนขออนุมัติงบประมาณประจำปี ' + (parseInt(this.YearSel) + 543) + '.xls'">
                    <v-btn class="font-weight-bold" outlined color="primary" @click="ExportData">Export ข้อมูล</v-btn>
                  </download-excel>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="font-weight-bold" text color="red" @click="dialogExportPlanProj = false">ปิด</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </template>
  </v-container>
</template>

<script>
import axios from 'axios'
import ConstData from '../../const/Const'
import {mapActions, mapGetters} from "vuex";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import queryString from "query-string";
// import Vue from "vue";

export default {


  name: "PlanProject",
  data() {
    return {
      exportDepGroup: null,
      dialogExportPlanProj: false,
      exportType: null,
      exportType2: null,
      exportType3: null,
      exportType4: null,
      json_fields: {
        '#': 'index',
        'รหัสแผน': 'Project_code',
        "ชื่องาน / กิจกรรม": 'Project_name',
        "ช่วงเวลาที่คาดว่าจะจัด": 'Project_date',
        "วันที่เริ่มต้น": 'DateStart',
        "วันที่สิ้นสุด": 'DateEnd',
        "ประเภทแผน": 'Project_group_des',
        "หลักสูตร": 'Course_name',
        "งบประมาณที่ขอ": 'BudgetRequest',
        "จำนวน ช.ม.": 'CalHourse',
        "จำนวน เครดิต": 'CalCredit',
        "งาน / กิจกรรม ถูกจัดขึ้น": 'PLACE',
        "จัดโดย": 'WorkBy',
        "ชื่อผู้จัด": 'WorkByName',
        "เบอร์โทรติดต่อผู้กรอกข้อมูล": 'WorkByPhone',
        "สถานที่จัด": 'Location',
        "แผนของหน่วยงาน": 'Dep_Name',
        "แผนประจำปี": 'FiscalYear2',
        "รายละเอียด": 'Remarks',
        "วัตถุประสงค์": 'Objective',
        "กลุ่มเป้าหมาย": 'TargetGroup',
        "สถานะ": 'IsStatusName',
        "วันที่บันทึก": 'Create_Time',
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      RemarksCancelProj: '',
      dialogShowCencelRemarks: false,
      dialogShowHistoryExpenseReal: false,
      groupExpenseRealObj: null,
      ExpenseRealObj: null,
      dialogShowExpenseReal: false,
      expenseRealHistoryData: [],
      expenseRealHistoryHeader: [
        {text: "ชื่อรายการ", value: "Item"},
        {text: "จำนวนเงิน", value: "Mon_total"},
        {text: "", value: "action"},
      ],
      expenseDetailRealHistoryData: [],
      expenseDetailRealHistoryHeader: [
        {text: "ชื่อรายการ", value: "Expense_des"},
        {text: "จำนวนเงิน", value: "Mon_debit"},
        {text: "เดือนที่ทำรายการ", value: "Monthly"},
      ],
      ProjectObj: null,
      closeStatus: null,
      dialogCancelOrCloseProject: false,
      remarksCloseProject: '',
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      sortStatus: '1',
      selStatus: '0',
      dialogCompetency: false,
      dialogFile: false,
      dialogFileLog: false,
      maintain: false,
      objProject: null,
      episode: null,
      typeIsPlan: 'all',
      typeProjCat: 'all',
      YearSel: null,
      typeStatus2: 'A',
      IsPlan: null,
      PlanProject_code: '',
      Project_code_dump: '',
      itemCode: '',
      ProjectPlan: '',
      Project_plan: [],
      TypeCreateProject: '0',
      FiscalYearData: [],
      FiscalYearMenuData: [],
      projectDataToTable: [],
      allProjectDataToTable: [],
      allProjectDataToTableDump: [],
      projectDataToTableDump: [],
      rdoRegisterProject: '0',
      ProjectQuotaDepCount: 0,
      dateRegStart: '',
      dateRegEnd: '',
      MessageSuc: '',
      MessageError: '',
      ShowAlertErr: false,
      ShowAlertSuc: false,
      DepQuotaData: [],
      searchDepQuota: '',
      ChooseTypRegis: '1',
      ChooseTypRegis2: '0',
      ChkJoinPerson: true,
      ProjectQuotaCount: '',
      DepQuotaCount: '',
      groupDepart: [],
      ChooseTypeDep: '0',
      DepQuotaSelect: '',
      CheckAdmin: false,
      CheckSubAdmin: false,
      WorkGroupData: [],
      dialogLecturerDetail: false,
      LecturerDetail: [],
      Country_id: '',
      dialogLecturer: false,
      percent: 0,
      dialogTemplate: false,
      CheckLecturer: false,
      Lecturer: [],
      TemplateProject: [],
      LecturerToShow: [],
      Committee_ToShow: [],
      projectGroupToShow: [],
      headerLecturer: [
        {text: 'หัวข้อเรื่อง', value: 'subject'},
        {text: 'วันที่เริ่มต้น', value: 'date_start'},
        {text: 'วันที่สิ้นสุด', value: 'date_end'},
        {text: 'เวลาเริ่มต้น', value: 'time_start'},
        {text: 'เวลาสิ้นสุด', value: 'time_end'}
      ],
      DepQuotaHeader: [
        {text: 'ประเภท', value: 'type'},
        {text: 'ภาควิชา/หน่วยงาน', value: 'dep_name'},
        {text: 'จำนวน', value: 'count'},
        {text: '', value: 'action'},
      ],
      SubjectForLecturer: '',
      dateSForLecturer: '',
      dateEForLecturer: '',
      timeSForLecturer: '',
      timeEForLecturer: '',
      editor: DecoupledEditor,
      editorDataGenerate: '',
      editorDataFormDB: '',
      editorData: '',
      dialogLoading: false,
      Expense: 0,
      Openfile: ConstData.ConnectionHost + '/rest/files',
      CompetencyToShow: [],
      ReqMoney: '',
      Rm: '',
      selection: [],
      dialogDetail: false,
      itemToShow: null,
      searchCompe: '',
      isMobile: false,
      SelDelvNo: '',
      itemsSel: [],
      CompetencyData: [],
      proposal: [],
      dialogProposal: false,
      Period_code: '',
      period: [
        {
          'name': 'ระยะสั้น (ไม่เกิน 1 เดือน)',
          'id': '2'
        },
        {
          'name': 'ระยะยาว (มากกว่า 1 เดือน)',
          'id': '3'
        }
      ],
      RecordData: [],
      RecordDataDump: [],
      searchPerson: '',
      headersPerson: [
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'affiliation'},
        {text: 'ลงทะเบียน', value: 'status_reg'},
      ],
      JoinPerson: [],
      FileProject: [],
      LogFileProject: [],
      alert: false,
      txtAlert: [],
      tab: null,
      tabMenu: null,
      Competency_code: '',
      UPercent: '',
      competencyHeader: [
        {text: 'Competency', value: 'Competency_des'},
        {text: 'เปอเซ็นต์', value: 'UPercent'}
      ],
      competency_DataForSubmit: [],
      expenseCostSum: 0,
      DepCost: '',
      expenseCost: '',
      moneyCost: '',
      expense_DataForSubmit: [],
      expense_p_DataForSubmit: [],
      CheckStep1: true,
      e1: 1,
      steps: 8,
      vertical: true,
      altLabels: false,
      editable: true,
      Details_Cordi: false,
      CheckFiles: false,
      full_name: '',
      phone: '',
      perid: '',
      peridCommittee: '',
      Committee_code: '',
      radioGroup: '0',
      radioGroup2: '0',
      files: [],
      Project_Choose: '',
      ChooseCourse: '',
      posiCondi: '',
      levelCondi: '',
      WSYear_Condi: '',
      WEYear_Condi: '',
      Course_Choose: '',
      DataCondi: [],
      courseCondi: [],
      Project_code: '',
      Project_name: '',
      Course_code: '',
      FiscalYear: '',
      course_group: '',
      Project_type: '',
      WorkBy: '',
      WorkByName: '',
      WorkByPhone: '',
      Location: '',
      DateStart: '',
      DateEnd: '',
      CalHourse: '',
      CalCredit: '',
      PLACE: '',
      Province_id: '',
      Status: '',
      Remarks: '',
      ProjectLevel: '',
      App_doc_no: '',
      BudgetRequest: '',
      BudgetArrove: '',
      Project_group: '',
      D_Project: {
        Project_code: '',
        Project_name: '',
        Course_code: '',
        course_group: '',
        Project_type: '',
        WorkBy: '',
        Location: '',
        DateStart: '',
        DateEnd: '',
        CalHourse: '',
        CalCredit: '',
        PLACE: '',
        Province_id: '',
        Status: '',
        Remarks: '',
        ProjectLevel: '',
        App_doc_no: '',
        BudgetRequest: '',
        BudgetArrove: '',
        Project_group: '',
        FiscalYear: '',
        IsPlan: '',
        IsPlanStatus: '',
        Status_Reg: '',
        Status_Type_Reg: '',
        DateS_Reg: '',
        DateE_Reg: '',
        Status_Count_Reg: '',
        Count_Reg: '',
        Dep_Code: '',
        Create_By: '',
        Create_Time: '',
        Update_By: '',
        Update_Time: '',
      },
      expanded: [],
      singleExpand: false,
      search: '',
      search2: '',
      CoordinatorHeader: [
        {text: 'ชื่อ - สกุล', value: 'Name'},
        {text: 'ตำแหน่ง', value: 'position_com'},
        {text: 'เบอรโ์โทร', value: 'TEL'},
        {text: 'สถานะ', value: 'Committee_type'},
        {text: 'วิทยากร', value: 'Lecturer'},
      ],
      Coordinator: [],
      courseHeadersCondi: [
        {text: 'หลักสูตร', value: 'Course_name'}
      ],
      courseDataCondi: [],
      dataHeadersCondi: [
        {text: 'ตำแหน่ง', value: 'PosName'},
        {text: 'อายุงานเริ่มต้น', value: 'WSYear'},
        {text: 'อายุงานสิ้นสุด', value: 'WEYear'}
      ],
      dataDataCondi: [],
      projectNeed: false,
      picker: new Date().toISOString().substr(0, 10),
      landscape: false,
      reactive: false,
      fullWidth: false,
      showCurrent: true,
      month: false,
      multiple: false,
      readonly: false,
      disabled: false,
      enableEvents: false,
      PLACESelete: [
        {
          id: '0', detail: 'ภายในคณะ'
        },
        {
          id: '1', detail: 'ภายในมหาวิทยาลัย'
        },
        {
          id: '2', detail: 'ภายในจังหวัด'
        },
        {
          id: '3', detail: 'ต่างประเทศ'
        },
        {
          id: '4', detail: 'online'
        }
      ],
      WorkByData: [
        {
          id: 'D', detail: 'หน่วยงาน'
        },
        {
          id: 'F', detail: 'คณะ'
        },
        {
          id: 'U', detail: 'หน่วยงาน/คณะ มหาวิทยาลัย'
        },
        {
          id: 'P', detail: 'ภายนอก'
        },
        {
          id: 'C', detail: 'ร่วมโครงการ'
        },
      ],
      Menu: [
        {
          'id': 1,
          'value': 'จัดโครงการ'
        },
        {
          'id': 2,
          'value': 'จัดการข้อมูลโครงการ'
        },
        {
          'id': 3,
          'value': 'ข้อมูลเบิกจ่ายเงินโครงการ'
        }],
      projectType: [
        {
          id: '0',
          details: 'อบรม'
        },
        {
          id: '1',
          details: 'ดูงาน'
        },
        {
          id: '2',
          details: 'ประชุม'
        },
        {
          id: '3',
          details: 'นำเสนองาน'
        }
      ],
      workBy: [
        'Depart',
        'Faculty',
        'University',
        'Public C',
        'Co-Project'
      ],
      CourseType: [
        'ทั่วไป',
        'เฉพาะตำแหน่ง'
      ],
      DataCourse: {
        Project_code: '',
        Course_code: '',
        Credit: ''
      },
      rules: {
        required: value => !!value || 'Required.',
        counterCourse: value => value.length <= 8 || 'Max 8 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      allProjectHeader: [
        {
          text: 'รหัสหลักสูตร', class: 'HeaderTable',
          align: 'start',
          value: 'Project_code',
        },
        {text: 'หลักสูตร', value: 'full_Name'},
        {text: 'อนุมัติโดย', value: 'Approve'},
        {text: 'สถานะ', value: 'Project_Status'},
        {text: '', value: 'Project_Details'}
      ],
      courseHeaders: [
        {text: 'หลักสูตร', value: 'full_Name'},
        {text: 'สถานะ', value: 'IsPlanStatus'},
        {text: 'งบประมาณ', value: 'BudgetRequest'},
        {text: 'จำนวนเงินอนุมัติ', value: 'BudgetArrove'},
        {text: 'จำนวนเงินเบิกจ่าย', value: 'MoneyDisburse'},
        {text: '', value: 'Project_Details'}
      ],
      budgetHeader: [
        {text: 'รายการ', value: 'Expense_des'},
        {text: 'จำนวนเงิน', value: 'ReqMoney'},
        {text: 'หมายเหตุ', value: 'Rm'},
        {text: '', value: 'action'}
      ],
      budgetData: [],
    }
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      projectForApprove: 'Project/getProjectForApprove',
      ProjectFromFiscalYearUser: "Project/getProjectFromFiscalYearUser",
      cancelProjRemarks: "Project/getCancelProjRemarks",
      committee_Posi: 'Project/getComitteeType',
      Comittee_Data: 'Project/getComittee',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      textForPrint: 'Project/getTextForPrint',
      countryData: 'Project/getCountry',
      planProjectForApprove: 'Project/getProjectPlanApprove',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      ApproveMaster: 'Staff/getApproveMaster',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      Competency: 'Competency/getCompetency',
      ProjectCompetency: 'Project/getCompetency',
      ProjectExpense: 'Project/getProjectExpense',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      PermissionAdmin: 'Permission/getPermission',
      SubMenuPermiss: 'Permission/getSubMenuPermiss',
      IgnoreSubMenuPermiss: 'Permission/getIgnoreSubMenuPermiss',
      DateForPlan: 'Project/getDateForPlan',
      LogProject: 'Project/getLogProject',
      LogCompetencyProject: 'Project/getLogCompetency',
      LogFiles: 'Project/getLogFiles',
      TypeProject: 'Project/getTypeProject',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
      StatusProject: 'Project/getStatusProject',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectData: 'Project/initProjectData',
      initProjectDataForApprove: 'Project/initProjectDataForApprove',
      initPlanProjectDataForApprove: 'Project/initPlanProjectDataForApprove',
      initProjDataFromFiscalYearUser: "Project/initProjDataFromFiscalYearUser",
      getCancelRemarksProj: "Project/getCancelRemarksProj",
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      MangeTextForPrint: 'Project/MangeTextForPrint',
      initCountryData: 'Project/initCountryData',
      initProjectExpenseData: 'Project/initProjectExpenseData',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectCompetencyData: 'Project/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      initApproveMasterByType: 'Staff/initApproveMasterByType',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      getSubMenuPermissData: 'Permission/getSubMenuPermissData',
      getIgnoreSubMenuPermissData: 'Permission/getIgnoreSubMenuPermissData',
      initDateForPlan: 'Project/initDateForPlan',
      initLogProject: 'Project/initLogProject',
      initLogCompetencyProject: 'Project/initLogCompetencyProject',
      initLogFileProject: 'Project/initLogFileProject',
    }),
    init: function () {
      this.dialogLoading = true
      this.allProjectDataToTable = []
      this.projectDataToTable = []
      this.FiscalYearData = []
      this.FiscalYearMenuData = []
      const today = new Date()
      this.YearSel = (today.getMonth() + 1) >= 10 ? today.getFullYear() + 1 : today.getFullYear()
      this.initComitteeType()
      this.initCountryData()

      this.groupDepart = []

      if (this.CheckAdmin) {
        this.getPermissionDep({
          perid: this.MeData[0].perid
        }).then(resDep => {
          if (resDep) {
            const groupMap = {}
            this.depart.forEach(dep => {
              if (dep.dep_group_id && !groupMap[dep.dep_group_id]) {
                groupMap[dep.dep_group_id] = {
                  dep_group_id: dep.dep_group_id,
                  dep_group_name: dep.dep_group_name
                }
              }
            })

            // สร้างรายการ groupDepart โดยนำ Permission_Dep มาเทียบกับ depart และเก็บกลุ่มที่ตรงกัน (ไม่ซ้ำ)
            this.groupDepart = []
            if (this.Permission_Dep && this.Permission_Dep.length > 0) {
              this.Permission_Dep.forEach(perm => {
                const depMatch = this.depart.find(d => d.dep_id == perm.dep_id)
                if (depMatch && depMatch.dep_group_id && groupMap[depMatch.dep_group_id]) {
                  const grp = groupMap[depMatch.dep_group_id]
                  if (!this.groupDepart.find(g => g.dep_group_id === grp.dep_group_id)) {
                    this.groupDepart.push(grp)
                  }
                }
              })
            }
          }
        })
      } else if (this.CheckSubAdmin) {
        this.getPermissionDepUserData({
          perid: this.MeData[0].perid
        }).then(resDepUser => {
          if (resDepUser) {
            const groupMap = {}
            this.depart.forEach(dep => {
              if (dep.dep_group_id && !groupMap[dep.dep_group_id]) {
                groupMap[dep.dep_group_id] = {
                  dep_group_id: dep.dep_group_id,
                  dep_group_name: dep.dep_group_name
                }
              }
            })

            // สร้างรายการ groupDepart โดยนำ Permission_Dep_User มาเทียบกับ depart และเก็บกลุ่มที่ตรงกัน (ไม่ซ้ำ)
            this.groupDepart = []
            if (this.Permission_Dep_User && this.Permission_Dep_User.length > 0) {
              this.Permission_Dep_User.forEach(perm => {
                const depMatch = this.depart.find(d => d.dep_id == perm.dep_id)
                if (depMatch && depMatch.dep_group_id && groupMap[depMatch.dep_group_id]) {
                  const grp = groupMap[depMatch.dep_group_id]
                  if (!this.groupDepart.find(g => g.dep_group_id === grp.dep_group_id)) {
                    this.groupDepart.push(grp)
                  }
                }
              })
            }
          }
        })
      }

      for (var i = (new Date().getFullYear() - 1); i <= (new Date().getFullYear() + 1); i++) {
        this.FiscalYearData.push({
          year: i,
          yearth: i + 543
        })
      }

      for (var j = 2020; j <= (new Date().getFullYear() + 3); j++) {
        this.FiscalYearMenuData.push({
          year: j,
          yearth: j + 543
        })
      }

      // this.initProjectData({
      //   perid: this.MeData[0].perid
      // })

      /* this.initPlanProjectDataForApprove().then(res => {
        if (res) {
          if (this.planProjectForApprove.length > 0) {
            if (this.CheckAdmin) {
              this.getPermissionDep({
                perid: this.MeData[0].perid
              }).then(resDep => {
                if (resDep) {
                  this.projectDataToTable = []
                  this.planProjectForApprove.map(Project => {
                    if (Project.Approve == '1') {
                      // var DepData = this.Permission_Dep.filter(Dep => Project.dep_id == Dep.dep_id)
                      // var DepData = this.Permission_Dep.filter(Dep => (Project.dep_id == Dep.dep_id || Dep.dep_id == Project.Dep_Code))
                      var DepData = this.Permission_Dep.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                      var DepBy = this.depart.filter(depi => depi.dep_id == Project.Dep_Code)
                      if (DepData.length > 0) {
                        if (DepBy.length > 0) {
                          this.projectDataToTable.push({
                            ...Project,
                            full_Name: '' +
                                ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                                ' <div><span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: #42b983"> แผน : ' + (Project.IsPlan == '1' ? 'ในแผน' : Project.IsPlan == '0' ? 'นอกแผน' : '-') + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: #42b983"> หมวด : ' + (Project.Project_category == '1' ? 'พัฒนาบุคลากร' : Project.Project_category == '2' ? 'โครงการอื่นๆ' : Project.Project_category == '3' ? 'บริการวิชาการ' : Project.Project_category == '4' ? 'วิจัย' : '-') + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name: '') + '</span></div>' +
                                (Project.IsDataComplete == '0' ? '<p style="font-weight: bold;color: red">****ข้อมูลไม่สมบูรณ์****</p>' : ''),
                            Owner: true
                          })
                        } else if (DepBy.length == 0) {
                          this.projectDataToTable.push({
                            ...Project,
                            full_Name: '' +
                                ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                                ' <div><span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: #42b983"> แผน : ' + (Project.IsPlan == '1' ? 'ในแผน' : Project.IsPlan == '0' ? 'นอกแผน' : '-') + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: #42b983"> หมวด : ' + (Project.Project_category == '1' ? 'พัฒนาบุคลากร' : Project.Project_category == '2' ? 'โครงการอื่นๆ' : Project.Project_category == '3' ? 'บริการวิชาการ' : Project.Project_category == '4' ? 'วิจัย' : '-') + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name: '') + '</span></div>' +
                                (Project.IsDataComplete == '0' ? '<p style="font-weight: bold;color: red">****ข้อมูลไม่สมบูรณ์****</p>' : ''),
                            Owner: true
                          })
                        } else {
                          this.projectDataToTable.push({
                            ...Project,
                            full_Name: ' ' +
                                ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                                ' <div><span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: #42b983"> แผน : ' + (Project.IsPlan == '1' ? 'ในแผน' : Project.IsPlan == '0' ? 'นอกแผน' : '-') + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: #42b983"> หมวด : ' + (Project.Project_category == '1' ? 'พัฒนาบุคลากร' : Project.Project_category == '2' ? 'โครงการอื่นๆ' : Project.Project_category == '3' ? 'บริการวิชาการ' : Project.Project_category == '4' ? 'วิจัย' : '-') + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name: '') + '</span></div>' +
                                (Project.IsDataComplete == '0' ? '<p style="font-weight: bold;color: red">****ข้อมูลไม่สมบูรณ์****</p>' : ''),
                            Owner: true
                          })
                        }
                      }
                    }
                  })
                  this.dialogLoading = false
                  this.ChooseYearFiscal()
                } else {
                  this.dialogLoading = false
                }
              }).catch(resc => {
                if (resc) {
                  this.dialogLoading = false
                }
              })
            } else if (this.CheckSubAdmin) {
              this.getPermissionDepUserData({
                perid: this.MeData[0].perid
              }).then(resDep => {
                if (resDep) {
                  this.projectDataToTable = []
                  this.planProjectForApprove.map(Project => {
                    // var DepData = this.Permission_Dep_User.filter(Dep => Project.dep_id == Dep.dep_id)
                    var DepData = this.Permission_Dep_User.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                    var DepBy = this.depart.filter(depi => depi.dep_id == Project.Dep_Code)

                    if (DepData.length > 0) {
                      if (DepBy.length > 0) {
                        this.projectDataToTable.push({
                          ...Project,
                          full_Name: '' +
                              ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                              ' <div><span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span></div>' +
                              ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>' +
                              ' <div><span style="font-weight: bold;color: #42b983"> แผน : ' + (Project.IsPlan == '1' ? 'ในแผน' : Project.IsPlan == '0' ? 'นอกแผน' : '-') + '</span></div>' +
                              ' <div><span style="font-weight: bold;color: #42b983"> หมวด : ' + (Project.Project_category == '1' ? 'พัฒนาบุคลากร' : Project.Project_category == '2' ? 'โครงการอื่นๆ' : Project.Project_category == '3' ? 'บริการวิชาการ' : Project.Project_category == '4' ? 'วิจัย' : '-') + '</span></div>' +
                              ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name: '') + '</span></div>' +
                              (Project.IsDataComplete == '0' ? '<p style="font-weight: bold;color: red">****ข้อมูลไม่สมบูรณ์****</p>' : ''),
                          Owner: true
                        })
                      } else if (DepBy.length == 0) {
                        this.projectDataToTable.push({
                          ...Project,
                          full_Name: '' +
                              ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                              ' <div><span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span></div>' +
                              ' <div><span style="font-weight: bold;color: #42b983"> แผน : ' + (Project.IsPlan == '1' ? 'ในแผน' : Project.IsPlan == '0' ? 'นอกแผน' : '-') + '</span></div>' +
                              ' <div><span style="font-weight: bold;color: #42b983"> หมวด : ' + (Project.Project_category == '1' ? 'พัฒนาบุคลากร' : Project.Project_category == '2' ? 'โครงการอื่นๆ' : Project.Project_category == '3' ? 'บริการวิชาการ' : Project.Project_category == '4' ? 'วิจัย' : '-') + '</span></div>' +
                              ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name: '') + '</span></div>' +
                              (Project.IsDataComplete == '0' ? '<p style="font-weight: bold;color: red">****ข้อมูลไม่สมบูรณ์****</p>' : ''),
                          Owner: true
                        })
                      } else {
                        this.projectDataToTable.push({
                          ...Project,
                          full_Name: '' +
                              ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                              ' <div><span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span></div>' +
                              ' <div><span style="font-weight: bold;color: #42b983"> แผน : ' + (Project.IsPlan == '1' ? 'ในแผน' : Project.IsPlan == '0' ? 'นอกแผน' : '-') + '</span></div>' +
                              ' <div><span style="font-weight: bold;color: #42b983"> หมวด : ' + (Project.Project_category == '1' ? 'พัฒนาบุคลากร' : Project.Project_category == '2' ? 'โครงการอื่นๆ' : Project.Project_category == '3' ? 'บริการวิชาการ' : Project.Project_category == '4' ? 'วิจัย' : '-') + '</span></div>' +
                              (Project.IsDataComplete == '0' ? '<p style="font-weight: bold;color: red">****ข้อมูลไม่สมบูรณ์****</p>' : ''),
                          Owner: true
                        })
                      }
                    }
                  })
                  this.dialogLoading = false
                  this.ChooseYearFiscal()
                } else {
                  this.dialogLoading = false
                }
              }).catch(resc => {
                if (resc) {
                  this.dialogLoading = false
                }
              })
            }
          }
        }
      })
 */

      this.selProjFiscalYear()

      if (this.courseData.length == 0) {
        this.initCourseData()
      }

      if (this.positions.length == 0) {
        this.initPositionsData()
      }

      if (this.Comittee_Data.length == 0) {
        this.initComitteeData()
      }

      if (this.provinces_Data.length == 0) {
        this.initProvincesData()
      }

      this.initExpenseData({
        cost_type: this.TypeProject
      })

      if (this.Competency_Data.length == 0) {
        this.initCompetencyData()
      }

      if (this.projectGroup.length == 0) {
        this.initProjectGroupData()
      }

    },
    ChooseYearFiscal() {
      if (this.projectDataToTableDump.length == 0) {
        this.projectDataToTableDump = this.projectDataToTable
      }
      this.projectDataToTable = []
      this.projectDataToTable = this.projectDataToTableDump.filter(item => item.FiscalYear == this.YearSel)
      this.ChooseTypeStatus()
    },
    ChangeTypeProject() {
      console.log(this.TypeProject)
    },
    ChooseTypeStatus() {
      // if (this.allProjectDataToTableDump.length == 0) {
      //   this.allProjectDataToTableDump = this.projectDataToTable
      // }
      // this.projectDataToTable = []
      // if (this.typeStatus2 == '8') {
      //   this.projectDataToTable = this.allProjectDataToTableDump
      // } else {
      //   this.projectDataToTable = this.allProjectDataToTableDump.filter(item => item.IsPlanStatus == this.typeStatus2)
      // }

      this.projectDataToTable = []
      if (this.projectDataToTableDump.length > 0) {
        if (this.typeStatus2 == 'A') {
          if (this.typeIsPlan == 'all') {
            if (this.typeProjCat == 'all') {
              this.projectDataToTable = this.projectDataToTableDump.filter(item => item.Project_type == this.TypeProject && item.FiscalYear == this.YearSel)
            } else {
              this.projectDataToTable = this.projectDataToTableDump.filter(item => item.Project_type == this.TypeProject && item.FiscalYear == this.YearSel && item.Project_category == this.typeProjCat)
            }
          } else {
            if (this.typeProjCat == 'all') {
              this.projectDataToTable = this.projectDataToTableDump.filter(item => item.Project_type == this.TypeProject && item.FiscalYear == this.YearSel && item.IsPlan == this.typeIsPlan)
            } else {
              this.projectDataToTable = this.projectDataToTableDump.filter(item => item.Project_type == this.TypeProject && item.FiscalYear == this.YearSel && item.IsPlan == this.typeIsPlan && item.Project_category == this.typeProjCat)
            }
          }
        } else {
          if (this.typeIsPlan == 'all') {
            if (this.typeProjCat == 'all') {
              this.projectDataToTable = this.projectDataToTableDump.filter(item => item.Project_type == this.TypeProject && item.FiscalYear == this.YearSel && item.IsPlanStatus == this.typeStatus2)
            } else {
              this.projectDataToTable = this.projectDataToTableDump.filter(item => item.Project_type == this.TypeProject && item.FiscalYear == this.YearSel && item.IsPlanStatus == this.typeStatus2 && item.Project_category == this.typeProjCat)
            }
          } else {
            if (this.typeProjCat == 'all') {
              this.projectDataToTable = this.projectDataToTableDump.filter(item => item.Project_type == this.TypeProject && item.FiscalYear == this.YearSel && item.IsPlanStatus == this.typeStatus2 && item.IsPlan == this.typeIsPlan)
            } else {
              this.projectDataToTable = this.projectDataToTableDump.filter(item => item.Project_type == this.TypeProject && item.FiscalYear == this.YearSel && item.IsPlanStatus == this.typeStatus2 && item.IsPlan == this.typeIsPlan && item.Project_category == this.typeProjCat)
            }
          }
        }
      }
    },
    ShowDetailLecturer(item) {
      this.LecturerDetail = []
      this.LecturerDetail = this.WorkGroupData.filter(L_item => L_item.perid == item.Perid && L_item.type == item.Committee_code)
      this.dialogLecturerDetail = true
    },
    onProgress(evt) {
      console.log(evt)
      this.percent = 0
      this.percent = evt
    },
    hasGenerated(evt) {
      console.log(evt)
    },
    hasStartedGeneration(evt) {
      console.log(evt)
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf()
    },
    ShowTemplate() {
      // this.dialogTemplate = true
      // this.generateReport()
      let routeData = this.$router.resolve({name: 'PrintFormProject', query: {data: this.editorData}});
      window.open(routeData.href, '_blank', 'location=yes,height=800,width=800,scrollbars=yes,status=yes');
    },
    SelProjectGroup() {
      if (this.projectGroup.filter(item => item.Project_group == this.Project_group).length > 0) {
        this.projectGroupToShow = this.projectGroup.filter(item => item.Project_group == this.Project_group)[0].Project_group_des
      } else {
        this.projectGroupToShow = ''
      }
    },
    AddWorkGuest() {
      if (this.SubjectForLecturer != '' && this.dateSForLecturer != '' && this.dateEForLecturer != '' && this.timeSForLecturer != '' && this.timeEForLecturer != '') {
        this.Lecturer.push({
          perid: this.perid,
          subject: this.SubjectForLecturer,
          date_start: this.dateSForLecturer,
          date_end: this.dateEForLecturer,
          time_start: this.timeSForLecturer,
          time_end: this.timeEForLecturer
        })
        this.SubjectForLecturer = ''
        this.dateSForLecturer = ''
        this.dateEForLecturer = ''
        this.timeSForLecturer = ''
        this.timeEForLecturer = ''
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุข้อมูลให้ครบถ้วน'
        })
      }
    },
    DocumentExec() {
      this.formprint1 = this.editorData
      // axios({
      //   url: 'http://localhost:3006/exec/test', //your url
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', 'file.docx'); //or any other extension
      //   document.body.appendChild(link);
      //   link.click();
      // });
    },
    PrintForm() {
      axios.post('http://localhost:3006/exec/docx', {
        data: {
          val1: this.formprint1, // หลักการและเหตุผล
          val2: this.formprint2, // วัตถุประสงค์
          val3: this.formprint3, // กลุ่มเป้าหมาย
          val4: this.formprint4, // วิธีการจัดอบรม
          val5: this.formprint5, // ระยะเวลาการจัดอบรม
          val6: this.formprint6, // สถานที่จัดอบรม
          val7: this.formprint7, // ผลที่คาดว่าจะได้รับ
          val8: this.formprint8, // ผู้รับผิดชอบโครงการ
          val9: this.formprint9, // ผู้รับผิดชอบโครงการ
          val10: this.formprint10, // วิทยากร
          val11: this.formprint11, // งบประมาณ
          val12: this.formprint12, // หมายเหตุ
          budget: this.budgetData,
          Lecturer: this.LecturerToShow,
          Committee: this.Committee_ToShow,
          projectGroup: this.projectGroupToShow,
          projectname: this.Project_name,
          projectcode: '01010-0220-1541'
        }
      }).then((res) => {
        console.log(res.data)
      })
      // axios({
      //   url: 'http://localhost:3006/exec/test', //your url
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', 'file.pdf'); //or any other extension
      //   document.body.appendChild(link);
      //   link.click();
      // });
      // this.$htmlToPaper('printForm');
      // this.MangeTextForPrint({
      //     process: 'SET',
      //     message: this.editorData
      // }).then(res => {
      //     if (res) {
      //         // console.log(this.textForPrint)
      //         this.$router.push({name: 'PrintFormProject'});
      //         // window.open(routeData.href, '_blank');
      //         // console.log('------------------------------------')
      //         // console.log(this.textForPrint)
      //
      //     }
      // })
    },
    BackMenu() {
      this.Details_Cordi = false
    },
    onInput(val) {
      this.steps = parseInt(val)
    },
    backStep(n) {
      this.e1 = n
    },
    nextStep(n) {
      if (n === this.steps) {
        this.e1 = 1
      } else {
        this.e1 = n + 1
      }
    },
    ShowCompeDetail(item) {
      this.dialogDetail = true
      this.itemToShow = null
      this.itemToShow = item
    },
    showCompetency(item) {
      this.CompetencyToShow = []
      var urlConnection = ''
      this.dialogLoading = true
      urlConnection = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency_view/Project_code/' + item.Project_code
      axios.get(urlConnection).then(res => {
        if (res.data) {
          this.dialogCompetency = true
          this.dialogLoading = false
          if (res.data.length > 0) {
            res.data.map(posi_i => {
              this.Competency.map(compe_i => {
                if (posi_i.DelvCover == compe_i.DelvNo) {
                  if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                    this.Competency.map(compe_i2 => {
                      if (compe_i.DelvCover == compe_i2.DelvNo) {
                        var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i2.DelvNo)

                        if (CheckCompetency.length == 0) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      }
                    })

                    // lv1
                    if (this.CompetencyToShow.length > 0) {
                      this.CompetencyToShow.map(ComToShow => {
                        if (ComToShow.children.length > 0) {
                          ComToShow.children.map((ComToShow_c, idx_to_Show) => {
                            CheckCompetency = false
                            if (compe_i.DelvNo == ComToShow_c.DelvNo) {
                              CheckCompetency = true
                            }
                            if (!CheckCompetency && idx_to_Show == ComToShow.children.length - 1) {
                              this.CompetencyToShow.map((data_i, idx) => {
                                if (data_i.DelvNo == compe_i.DelvCover) {
                                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes,
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  } else {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  }
                                }
                              })
                            }
                          })
                        } else {
                          this.CompetencyToShow.map((data_i, idx) => {
                            if (data_i.DelvNo == compe_i.DelvCover) {
                              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes,
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              } else {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              }
                            }
                          })
                        }
                      })
                    }

                    //lv2
                    this.CompetencyToShow.map((data_i, idx) => {
                      data_i.children.map((child_i, c_idx) => {
                        if (child_i.DelvNo == posi_i.DelvCover) {
                          if (posi_i.DelvEng == null || posi_i.DelvEng == '') {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes,
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes + '( ' + posi_i.DelvEng + ' )',
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    })
                  } else {
                    var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i.DelvNo)

                    if (CheckCompetency.length == 0) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      }
                    }

                    this.Competency.map(compe_i2 => {
                      if (posi_i.DelvNo == compe_i2.DelvNo) {
                        this.CompetencyToShow.map((data_i, idx) => {
                          if (data_i.DelvNo == posi_i.DelvCover) {
                            if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes,
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            } else {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            }
                          }
                        })
                      }
                    })
                  }
                }
              })
            })
          } else {
            // root
            this.Competency.map(compe_i => {
              if (res.data.DelvCover == compe_i.DelvNo) {
                if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                  this.Competency.map(compe_i2 => {
                    if (compe_i.DelvCover == compe_i2.DelvNo) {
                      if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i2,
                          id: compe_i2.DelvNo,
                          name: compe_i2.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i2,
                          id: compe_i2.DelvNo,
                          name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      }
                    }
                  })

                  // lv1
                  this.CompetencyToShow.map((data_i, idx) => {
                    if (data_i.DelvNo == compe_i.DelvCover) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '1',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '1',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      }
                    }
                  })

                  //lv2
                  this.CompetencyToShow.map((data_i, idx) => {
                    data_i.children.map((child_i, c_idx) => {
                      if (child_i.DelvNo == res.data.DelvCover) {
                        if (res.data.DelvEng == null || res.data.DelvEng == '') {
                          this.CompetencyToShow[idx].children[c_idx].children.push({
                            ...res.data,
                            id: res.data.DelvNo,
                            name: res.data.DelvDes,
                            DelvLevel: '2',
                            NeedsCredit: res.data.NeedsCredit,
                            ExpectCredit: res.data.ExpectCredit,
                            children: []
                          })
                        } else {
                          this.CompetencyToShow[idx].children[c_idx].children.push({
                            ...res.data,
                            id: res.data.DelvNo,
                            name: res.data.DelvDes + '( ' + res.data.DelvEng + ' )',
                            DelvLevel: '2',
                            NeedsCredit: res.data.NeedsCredit,
                            ExpectCredit: res.data.ExpectCredit,
                            children: []
                          })
                        }
                      }
                    })
                  })
                } else {
                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                    this.CompetencyToShow.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes,
                      DelvLevel: '0',
                      NeedsCredit: res.data.NeedsCredit,
                      ExpectCredit: res.data.ExpectCredit,
                      children: []
                    })
                  } else {
                    this.CompetencyToShow.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                      DelvLevel: '0',
                      NeedsCredit: res.data.NeedsCredit,
                      ExpectCredit: res.data.ExpectCredit,
                      children: []
                    })
                  }

                  this.Competency.map(compe_i2 => {
                    if (res.data.DelvNo == compe_i2.DelvNo) {
                      this.CompetencyToShow.map((data_i, idx) => {
                        if (data_i.DelvNo == res.data.DelvCover) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow[idx].children.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '1',
                              NeedsCredit: res.data.NeedsCredit,
                              ExpectCredit: res.data.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '1',
                              NeedsCredit: res.data.NeedsCredit,
                              ExpectCredit: res.data.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    }
                  })
                }
              }
            })
          }
        } else {
          this.dialogCompetency = true
          this.dialogLoading = false
          // Error Competency
        }
      }).catch(res => {
        if (res) {
          this.dialogCompetency = true
          this.dialogLoading = false
        }
      })
    },
    showFile() {
      this.dialogFile = true
    },
    showLogCompetency(item) {
      this.CompetencyToShow = []
      this.dialogLoading = true
      this.initLogCompetencyProject({
        Ref_id: item.Ref_id
      }).then(res => {
        if (res) {
          this.dialogCompetency = true
          this.dialogLoading = false
          if (this.LogCompetencyProject.length > 0) {
            this.LogCompetencyProject.map(posi_i => {
              this.Competency.map(compe_i => {
                if (posi_i.DelvCover == compe_i.DelvNo) {
                  if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                    this.Competency.map(compe_i2 => {
                      if (compe_i.DelvCover == compe_i2.DelvNo) {
                        var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i2.DelvNo)

                        if (CheckCompetency.length == 0) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      }
                    })

                    // lv1
                    if (this.CompetencyToShow.length > 0) {
                      this.CompetencyToShow.map(ComToShow => {
                        if (ComToShow.children.length > 0) {
                          ComToShow.children.map((ComToShow_c, idx_to_Show) => {
                            CheckCompetency = false
                            if (compe_i.DelvNo == ComToShow_c.DelvNo) {
                              CheckCompetency = true
                            }
                            if (!CheckCompetency && idx_to_Show == ComToShow.children.length - 1) {
                              this.CompetencyToShow.map((data_i, idx) => {
                                if (data_i.DelvNo == compe_i.DelvCover) {
                                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes,
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  } else {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  }
                                }
                              })
                            }
                          })
                        } else {
                          this.CompetencyToShow.map((data_i, idx) => {
                            if (data_i.DelvNo == compe_i.DelvCover) {
                              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes,
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              } else {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              }
                            }
                          })
                        }
                      })
                    }

                    //lv2
                    this.CompetencyToShow.map((data_i, idx) => {
                      data_i.children.map((child_i, c_idx) => {
                        if (child_i.DelvNo == posi_i.DelvCover) {
                          if (posi_i.DelvEng == null || posi_i.DelvEng == '') {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes,
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes + '( ' + posi_i.DelvEng + ' )',
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    })
                  } else {
                    var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i.DelvNo)

                    if (CheckCompetency.length == 0) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      }
                    }

                    this.Competency.map(compe_i2 => {
                      if (posi_i.DelvNo == compe_i2.DelvNo) {
                        this.CompetencyToShow.map((data_i, idx) => {
                          if (data_i.DelvNo == posi_i.DelvCover) {
                            if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes,
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            } else {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            }
                          }
                        })
                      }
                    })
                  }
                }
              })
            })
          }
        } else {
          this.dialogLoading = false
          this.dialogCompetency = true
          // Error Competency
        }
      })
    },
    showLogFile(item) {
      this.dialogFileLog = true
      this.dialogLoading = true
      this.LogFileProject = []
      this.initLogFileProject({
        Ref_id: item.Ref_id
      }).then(res => {
        if (res) {
          if (this.LogFiles.length > 0) {
            this.LogFiles.map((item) => {
              switch (item.File_type) {
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/gif':
                case 'image/bmp':
                case 'image/png':
                  this.LogFileProject.push({
                    id: item.id,
                    name: item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                    path: item.File_path,
                    type: 'image',
                    type_Img: item.File_type
                  })
                  break
                case 'application/pdf':
                  this.LogFileProject.push({
                    id: item.id,
                    name: item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                    path: item.File_path,
                    type: 'pdf',
                    type_Img: item.File_type
                  })
                  break
                default:
                  break
              }
            })
          }
        }
        this.dialogLoading = false
      }).catch(res => {
        if (res) {
          this.dialogLoading = false
        }
      })
    },
    ShowData: function (dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );

    },
    getTrainFiles(Ref_id) {
      return new Promise(resolve => {
        var dumpArr = []
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/Ref_id/' + Ref_id).then(res => {
          if (res.data) {
            if (res.data.length > 0) {
              dumpArr = res.data
            } else {
              dumpArr.push(res.data)
            }
          } else {
            dumpArr = []
          }
          resolve(dumpArr)
        })
      })
    },
    DelProjectOwner(item) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการลบข้อมูลเสนอแผน " + item.Project_name + ' ใช่หรือไม่ ??',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          const headerAxios = {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'DELETE'
            }
          }
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + item.Project_code, '', headerAxios)
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + item.Project_code + '/?limit=1', '', {
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(res => {
            if (res.data) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + item.Project_code, '', headerAxios)
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/Ref_id/' + res.data.Ref_id, '', headerAxios)
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Lecturer/Ref_id/' + res.data.Ref_id, '', headerAxios)
            }
          })

          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_expense/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_committee/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_round/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/TemplateProject/Project_code/' + item.Project_code, '', headerAxios)

          setTimeout(() => {
            this.$swal.fire({
              timer: 1500,
              showConfirmButton: false,
              icon: 'success',
              title: 'ลบข้อมูลเสนอแผน  ' + item.Project_name + '  สำเร็จ!!'
            }, 1500)
            this.init()
          })
        }
      })
    },
    remarksProject(item, status) {
      this.ProjectObj = item
      this.closeStatus = status
      this.dialogCancelOrCloseProject = true
    },
    DelProject(item) {
      this.CheckPermission().then(res => {
        if (res) {
          this.$swal.fire({
            title: 'ยืนยันการทำรายการ',
            text: "คุณต้องการลบข้อมูลเสนอแผน " + item.Project_name + ' ใช่หรือไม่ ??',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.value) {
              axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
                queryName: 'deleteProjData',
                param: btoa(JSON.stringify({
                  id: item.Project_code,
                  Update_By: this.MeData[0].perid
                }))
              }).then(res => {
                if (res.data.status) {
                  setTimeout(() => {
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'ลบข้อมูลเสนอแผน  ' + item.Project_name + '  สำเร็จ!!'
                    }, 1500)
                    this.selProjFiscalYear()
                  })
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาดไม่สามารถลบข้อมูลได้ โปรดลองอีกครั้ง'
                  })
                }
              })
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    ShowDetail(item) {
      this.dialogLoading = true
      this.e1 = '1'
      this.Expense = 0
      this.episode = null
      this.objProject = null

      this.files = []
      this.Coordinator = []
      this.courseCondi = []
      this.competency_DataForSubmit = []
      this.expense_DataForSubmit = []
      this.expense_p_DataForSubmit = []
      this.FileProject = []
      this.DataCondi = []
      this.JoinPerson = []
      this.budgetData = []
      this.Lecturer = []
      this.TemplateProject = []
      this.DepQuotaData = []
      this.RecordData = []

      this.editorData = ''

      this.Details_Cordi = true
      this.objProject = item
      this.Project_code = item.Project_code
      this.Project_name = item.Project_name
      this.Course_code = item.Course_code
      this.course_group = item.Course_group
      this.Period_code = item.Period_code
      this.Project_type = item.Project_type
      this.Remarks = item.Remarks
      this.CalCredit = item.CalCredit
      this.CalHourse = item.CalHourse
      this.PLACE = item.PLACE
      this.Province_id = item.Province_id
      this.Country_id = item.Country_id
      this.BudgetRequest = item.BudgetRequest
      this.Location = item.Location
      this.WorkBy = item.WorkBy
      this.WorkByName = item.WorkByName
      this.WorkByPhone = item.WorkByPhone
      this.DateStart = item.DateStart
      this.DateEnd = item.DateEnd
      this.DepSelect = item.Dep_Code
      this.Project_group = item.Project_group
      this.FiscalYear = parseInt(item.FiscalYear)
      this.IsPlan = item.IsPlan
      this.itemCode = item.Item_Code

      this.ChooseTypeDep = item.Approve
      this.ChooseTypRegis = item.Status_Reg
      this.ChooseTypRegis2 = item.Status_Type_Reg
      this.dateRegStart = item.DateS_Reg
      this.dateRegEnd = item.DateE_Reg
      this.ProjectQuotaCount = item.Count_Reg
      if (item.Status_Count_Reg == '0') {
        this.ChkJoinPerson = false
      } else {
        this.ChkJoinPerson = true
      }

      // this.showCompetency(item)
      this.initLogProject({
        Project_code: this.Project_code
      })

      if ((this.DateStart == (parseInt(this.FiscalYear) - 1) + '-10-01') && (this.DateEnd == (parseInt(this.FiscalYear) - 1) + '-12-31')) {
        this.episode = '1'
      } else if ((this.DateStart == this.FiscalYear + '-01-01') && (this.DateEnd == this.FiscalYear + '-03-31')) {
        this.episode = '2'
      } else if ((this.DateStart == this.FiscalYear + '-04-01') && (this.DateEnd == this.FiscalYear + '-06-30')) {
        this.episode = '3'
      } else if ((this.DateStart == this.FiscalYear + '-07-01') && (this.DateEnd == this.FiscalYear + '-09-30')) {
        this.episode = '4'
      } else {
        this.episode = null
      }

      this.initProjectCompetencyData({
        Project_code: this.Project_Choose
      }).then(res => {
        if (res) {
          this.ProjectCompetency.map(ProjectCom => {
            this.selection.push(ProjectCom.DelvNo)
          })
          this.logSelection = this.selection
        }
      })

      this.initProjectExpenseData({
        Project_code: this.Project_code
      }).then(res => {
        if (res) {
          this.ProjectExpense.map(ProjectEx => {
            this.expense_Data.map(expenseData => {
              if (ProjectEx.Expense_id == expenseData.Expense_id) {
                this.budgetData.push({
                  Expense_id: expenseData.Expense_id,
                  Expense_des: expenseData.Expense_des,
                  ReqMoney: ProjectEx.ReqMoney,
                  Rm: ProjectEx.Rm
                })
                this.Expense += parseFloat(ProjectEx.ReqMoney)
              }
            })

          })
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/quata_dep_reg/Project_code/' + this.Project_code).then(res => {
        if (res.data) {
          var type = ''
          if (res.data.length > 0) {
            this.projectNeed = true
            res.data.map((item_qua) => {
              type = ''
              if (item_qua.dep_type == '0') {
                type = 'หน่วยงาน/ภาควิชา'
              } else {
                type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
              }
              this.DepQuotaData.push({
                quotaType: item_qua.dep_type,
                type: type,
                type_id: item_qua.dep_type,
                dep_name: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_name,
                dep_id: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_id,
                dep_group_id: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_group_id,
                count: item_qua.count
              })
            })
          } else {
            this.projectNeed = true
            type = ''
            if (res.data.dep_type == '0') {
              type = 'หน่วยงาน/ภาควิชา'
            } else {
              type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
            }
            this.DepQuotaData.push({
              quotaType: res.data.dep_type,
              type: type,
              type_id: res.data.dep_type,
              dep_name: this.depart.filter(item => item.dep_id == res.data.dep_id)[0].dep_name,
              dep_id: this.depart.filter(item => item.dep_id == res.data.dep_id)[0].dep_id,
              dep_group_id: this.depart.filter(item => item.dep_id == res.data.dep_id)[0].dep_group_id,
              count: res.data.count
            })
          }

          if (this.DepQuotaData.length > 0) {
            this.DepQuotaData.map(item_dep_q => {
              this.ProjectQuotaDepCount += parseInt(item_dep_q.count)
            })
          }
        } else {
          this.projectNeed = false
          this.DepQuotaData = []
        }
      })


      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + item.Project_code).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.projectNeed = true
            this.WorkGroupData = res.data
          } else {
            this.projectNeed = true
            this.WorkGroupData.push(res.data)
          }

          if (this.WorkGroupData.length > 0) {
            this.WorkGroupData.map(item_w => {
              this.getTrainFiles(item_w.Ref_id).then(res => {
                item_w.files = res
              })
            })
          }
        } else {
          this.projectNeed = false
          this.WorkGroupData = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/TemplateProject/Project_code/' + item.Project_code).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.projectNeed = true
            this.TemplateProject = res.data
          } else {
            this.projectNeed = true
            this.TemplateProject.push(res.data)
          }
          if (this.TemplateProject.length > 0) {
            this.editorDataFormDB = this.TemplateProject[0].Template
            this.editorData = this.editorDataFormDB.replaceAll('&quot;', '"')
          }
        } else {
          this.projectNeed = false
          this.TemplateProject = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record_view/Project_code/' + item.Project_code + '/Type/1/?sort=id_DESC').then(res => {
        if (res.data) {

          if (res.data.length > 0) {
            this.RecordData = res.data
          } else {
            this.RecordData.push(res.data)
          }
          this.RecordData.map(item => {
            item.files = []
          })
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/active/1/Project_code/' + item.Project_code + '/?sort=id_DESC').then(res => {
            if (res.data) {
              this.dialogLoading = false
              // var files_Project = []
              if (res.data.length > 0) {
                res.data.map(file_i => {
                  this.RecordData.map(record_i => {
                    if (record_i.Project_code == file_i.Project_code && record_i.id == file_i.project_record_id) {
                      record_i.files.push(file_i)
                    }
                  })
                })
              } else {
                this.dialogLoading = false
                this.RecordData.map(record_i => {
                  if (record_i.Project_code == res.data.Project_code && record_i.id == res.data.project_record_id) {
                    record_i.files.push(res.data)
                  }
                })
              }
              this.RecordDataDump = this.RecordData
            } else {
              this.dialogLoading = false
              this.RecordDataDump = this.RecordData
            }
          })
        } else {
          this.dialogLoading = false
          this.RecordData = []
          this.RecordDataDump = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level_view/Project_code/' + item.Project_code).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.DataCondi = res.data
          } else {
            this.DataCondi.push(res.data)
          }
          if (this.DataCondi.length > 0) {
            this.DataCondi.map(item => {
              item.workAgeStart = item.WSYear
              item.workAgeEnd = item.WEYear
            })
          }
        } else {
          this.DataCondi = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_need_view/Project_code/' + item.Project_code).then(res => {
        if (res.data) {

          if (res.data.length > 0) {
            this.courseCondi = res.data
          } else {
            this.courseCondi.push(res.data)
          }
        } else {
          this.courseCondi = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_committee/Project_code/' + item.Project_code).then(res => {
        if (res.data) {

          if (res.data.length > 0) {
            this.Coordinator = res.data
          } else {
            this.Coordinator.push(res.data)
          }

          this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6')
          this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6')
          if (this.Committee_ToShow.length > 0) {
            this.Committee_ToShow.map(item => {
              item.Committee_des = this.committee_Posi.filter(commit_i => commit_i.Committee_code == item.Committee_code)[0].committee_des
            })
          }
          if (this.LecturerToShow.length > 0) {
            this.LecturerToShow.map(item => {
              item.Committee_des = this.committee_Posi.filter(commit_i => commit_i.Committee_code == item.Committee_code)[0].committee_des
            })
          }
        } else {
          this.projectNeed = false
          this.Coordinator = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/active/1/Type/0/Project_code/' + item.Project_code).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map((item) => {
              switch (item.File_type) {
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/gif':
                case 'image/bmp':
                case 'image/png':
                  this.FileProject.push({
                    name: item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                    path: item.File_path,
                    type: 'image',
                    type_Img: item.File_type
                  })
                  break
                case 'application/pdf':
                  this.FileProject.push({
                    name: item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                    path: item.File_path,
                    type: 'pdf',
                    type_Img: item.File_type
                  })
                  break
                default:
                  break
              }
            })
          } else {
            switch (res.data.File_type) {
              case 'image/jpg':
              case 'image/jpeg':
              case 'image/gif':
              case 'image/bmp':
              case 'image/png':
                this.FileProject.push({
                  name: res.data.File_name,
                  src: ConstData.ConnectionHost + '/rest/files' + res.data.File_path,
                  path: res.data.File_path,
                  type: 'image',
                  type_Img: res.data.File_type
                })
                break
              case 'application/pdf':
                this.FileProject.push({
                  name: res.data.File_name,
                  src: ConstData.ConnectionHost + '/rest/files' + res.data.File_path,
                  path: res.data.File_path,
                  type: 'pdf',
                  type_Img: res.data.File_type
                })
                break
              default:
                break
            }
          }
        } else {
          this.FileProject = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + item.Project_code).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map((item) => {
              this.JoinPerson.push({
                ...item,
                full_Name: item.name + ' ' + item.sname,
                idCard: item.id_card,
              })
            })
          } else {
            this.JoinPerson.push({
              ...res.data,
              full_Name: res.data.name + ' ' + res.data.sname,
              idCard: res.data.id_card,
            })
          }
        } else {
          this.JoinPerson = []
        }
      })
    },
    Project_proposal(item) {
      this.CheckPermission().then(res => {
        if (res) {
          this.proposal = []
          this.proposal = item
          this.dialogProposal = true
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    CheckPermission() {
      return new Promise(resolve => {
        var CheckPermiss = false
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == '10001') {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == '10001') {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    },
    iniPlanAfterAction() {
      this.initPlanProjectDataForApprove().then(res => {
        if (res) {
          if (this.planProjectForApprove.length > 0) {
            if (this.CheckAdmin) {
              this.getPermissionDep({
                perid: this.MeData[0].perid
              }).then(resDep => {
                if (resDep) {
                  this.projectDataToTable = []
                  this.projectDataToTableDump = []
                  this.planProjectForApprove.map(Project => {
                    // var DepCreate = this.staffData.filter(staffi => staffi.perid == Project.Create_By)
                    // var DepData = this.Permission_Dep.filter(Dep => Project.dep_id == Dep.dep_id)
                    var DepData = this.Permission_Dep.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                    var DepBy = this.depart.filter(depi => depi.dep_id == Project.Dep_Code)
                    if (DepData.length > 0) {
                      if (DepBy.length > 0) {
                        this.projectDataToTable.push({
                          ...Project,
                          full_Name: '' +
                              ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                              ' <div><span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span></div>' +
                              ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>' +
                              ' <div><span style="font-weight: bold;color: #42b983"> แผน : ' + (Project.IsPlan == '1' ? 'ในแผน' : Project.IsPlan == '0' ? 'นอกแผน' : '-') + '</span></div>' +
                              ' <div><span style="font-weight: bold;color: #42b983"> หมวด : ' + (Project.Project_category == '1' ? 'พัฒนาบุคลากร' : Project.Project_category == '2' ? 'โครงการอื่นๆ' : Project.Project_category == '3' ? 'บริการวิชาการ' : Project.Project_category == '4' ? 'วิจัย' : '-') + '</span></div>' +
                              ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name: '') + '</span></div>' +
                              (Project.IsDataComplete == '0' ? '<p style="font-weight: bold;color: red">****ข้อมูลไม่สมบูรณ์****</p>' : ''),
                          Owner: true
                        })
                      } else if (DepBy.length == 0) {
                        this.projectDataToTable.push({
                          ...Project,
                          full_Name: '' +
                              ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                              ' <div><span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span></div>' +
                              ' <div><span style="font-weight: bold;color: #42b983"> แผน : ' + (Project.IsPlan == '1' ? 'ในแผน' : Project.IsPlan == '0' ? 'นอกแผน' : '-') + '</span></div>' +
                              ' <div><span style="font-weight: bold;color: #42b983"> หมวด : ' + (Project.Project_category == '1' ? 'พัฒนาบุคลากร' : Project.Project_category == '2' ? 'โครงการอื่นๆ' : Project.Project_category == '3' ? 'บริการวิชาการ' : Project.Project_category == '4' ? 'วิจัย' : '-') + '</span></div>' +
                              ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name: '') + '</span></div>' +
                              (Project.IsDataComplete == '0' ? '<p style="font-weight: bold;color: red">****ข้อมูลไม่สมบูรณ์****</p>' : ''),
                          Owner: true
                        })
                      } else {
                        this.projectDataToTable.push({
                          ...Project,
                          full_Name: '' +
                              ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                              ' <div><span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span></div>' +
                              ' <div><span style="font-weight: bold;color: #42b983"> แผน : ' + (Project.IsPlan == '1' ? 'ในแผน' : Project.IsPlan == '0' ? 'นอกแผน' : '-') + '</span></div>' +
                              ' <div><span style="font-weight: bold;color: #42b983"> หมวด : ' + (Project.Project_category == '1' ? 'พัฒนาบุคลากร' : Project.Project_category == '2' ? 'โครงการอื่นๆ' : Project.Project_category == '3' ? 'บริการวิชาการ' : Project.Project_category == '4' ? 'วิจัย' : '-') + '</span></div>' +
                              (Project.IsDataComplete == '0' ? '<p style="font-weight: bold;color: red">****ข้อมูลไม่สมบูรณ์****</p>' : ''),
                          Owner: true
                        })
                      }
                    }
                  })
                  this.ChooseYearFiscal()
                  this.dialogLoading = false
                } else {
                  this.dialogLoading = false
                }
              })
            } else if (this.CheckSubAdmin) {
              this.getPermissionDepUserData({
                perid: this.MeData[0].perid
              }).then(resDep => {
                if (resDep) {
                  this.projectDataToTable = []
                  this.planProjectForApprove.map(Project => {
                      // var DepCreate = this.staffData.filter(staffi => staffi.perid == Project.Create_By)
                      // var DepData = this.Permission_Dep_User.filter(Dep => Project.dep_id == Dep.dep_id)
                      var DepData = this.Permission_Dep_User.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                      var DepBy = this.depart.filter(depi => depi.dep_id == Project.Dep_Code)
                      if (DepData.length > 0) {
                        if (DepBy.length > 0) {
                          this.projectDataToTable.push({
                            ...Project,
                            full_Name: '' +
                                ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                                ' <div><span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: #42b983"> แผน : ' + (Project.IsPlan == '1' ? 'ในแผน' : Project.IsPlan == '0' ? 'นอกแผน' : '-') + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: #42b983"> หมวด : ' + (Project.Project_category == '1' ? 'พัฒนาบุคลากร' : Project.Project_category == '2' ? 'โครงการอื่นๆ' : Project.Project_category == '3' ? 'บริการวิชาการ' : Project.Project_category == '4' ? 'วิจัย' : '-') + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name: '') + '</span></div>' +
                                (Project.IsDataComplete == '0' ? '<p style="font-weight: bold;color: red">****ข้อมูลไม่สมบูรณ์****</p>' : ''),
                            Owner: true
                          })
                        } else if (DepBy.length == 0) {
                          this.projectDataToTable.push({
                            ...Project,
                            full_Name: '' +
                                ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                                ' <div><span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: #42b983"> แผน : ' + (Project.IsPlan == '1' ? 'ในแผน' : Project.IsPlan == '0' ? 'นอกแผน' : '-') + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: #42b983"> หมวด : ' + (Project.Project_category == '1' ? 'พัฒนาบุคลากร' : Project.Project_category == '2' ? 'โครงการอื่นๆ' : Project.Project_category == '3' ? 'บริการวิชาการ' : Project.Project_category == '4' ? 'วิจัย' : '-') + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name: '') + '</span></div>' +
                                (Project.IsDataComplete == '0' ? '<p style="font-weight: bold;color: red">****ข้อมูลไม่สมบูรณ์****</p>' : ''),
                            Owner: true
                          })
                        } else {
                          this.projectDataToTable.push({
                            ...Project,
                            full_Name: '' +
                                ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                                ' <div><span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: #42b983"> แผน : ' + (Project.IsPlan == '1' ? 'ในแผน' : Project.IsPlan == '0' ? 'นอกแผน' : '-') + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: #42b983"> หมวด : ' + (Project.Project_category == '1' ? 'พัฒนาบุคลากร' : Project.Project_category == '2' ? 'โครงการอื่นๆ' : Project.Project_category == '3' ? 'บริการวิชาการ' : Project.Project_category == '4' ? 'วิจัย' : '-') + '</span></div>' +
                                (Project.IsDataComplete == '0' ? '<p style="font-weight: bold;color: red">****ข้อมูลไม่สมบูรณ์****</p>' : ''),
                            Owner: true
                          })
                        }
                      }
                  })
                  this.dialogLoading = false
                } else {
                  this.dialogLoading = false
                }
              })
            }
          }
        }
      })
    },
    proposal_To_Db() {
      const param = {
        IsPlanStatus: (((this.proposal.Project_type == '1' || (this.proposal.Project_type == '2' && (this.proposal.IsProcess == '1' || this.proposal.IsProcess == '3')))) ? '1' : (this.proposal.Project_type == '2' && this.proposal.IsProcess != '1') ? '2' : '1')
      }

      const headerAxios = {
        headers: {
          'Content-Type': 'application/json'
        }
      }

      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.proposal.Project_code, param, headerAxios).then(res => {
        if (res.data.status) {
          this.dialogProposal = false
          this.initApproveMasterByType({
            type: this.proposal.Project_category
          }).then(res => {
            if (res) {
              if (this.ApproveMaster.length > 0) {
                var SendMailApprove = this.ApproveMaster.filter(Approveitem => Approveitem.type == this.proposal.Project_category && Approveitem.sendmail == '1' && (Approveitem.Approve_Project_Type_Ms == '1' || Approveitem.Approve_Project_Type_Ms == '9') && Approveitem.readonly == '0' && Approveitem.project_type != '2')
                if (SendMailApprove.length > 0) {
                  SendMailApprove.map(SendMailI => {
                    this.SendMail(SendMailI)
                  })
                }
              }
              this.$swal.fire({
                timer: 1500,
                showConfirmButton: false,
                icon: 'success',
                title: 'เสนอข้อมูลเสนอแผน  ' + this.proposal.Project_name + '  สำเร็จ!!'
              }, 1500)
            }
          })
          this.selProjFiscalYear()
        }
      })
    },
    GetData(item, IsExp, FuncExp) {
      this.DataCondi = []
      this.courseCondi = []
      if (IsExp) {
        FuncExp(false)
      } else {
        FuncExp(true)

        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level_view/Project_code/' + item.Project_code).then(res => {
          if (res.data) {

            if (res.data.length > 0) {
              this.DataCondi = res.data
            } else {
              this.DataCondi.push(res.data)
            }
          } else {
            this.DataCondi = []
          }
        })

        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_need_view/Project_code/' + item.Project_code).then(res => {
          if (res.data) {

            if (res.data.length > 0) {
              this.courseCondi = res.data
            } else {
              this.courseCondi.push(res.data)
            }
          } else {
            this.courseCondi = []
          }
        })
      }
    },
    ChangeStatus: function (item) {
      if (item.Course_status == '1') {
        const param = {
          Course_status: '9'
        }

        const headerAxios = {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course/Course_code/' + item.Course_code, param, headerAxios).then(res => {
          if (res.data) {
            this.init()
          }
        })
      } else {
        const param = {
          Course_status: '1'
        }

        const headerAxios = {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course/Course_code/' + item.Course_code, param, headerAxios).then(res => {
          if (res.data.status) {
            this.init()
          }
        })
      }
    },
    SendMail(obj) {
      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
        perid_admin: obj.perid,
        perid: this.proposal.Create_By,
        headerName: 'แจ้งเตือนการพิจารณาข้อมูลเสนอแผนตั้งงบประมาณประจำปี ' + this.proposal.Project_name + ' (' + this.proposal.Project_code + ')',
        header: this.proposal.Project_name + ' (' + this.proposal.Project_code + ')',
        body: '<p style="font-size: 25px;color: peru;font-weight: bold">มีการเสนอแผนตั้งงบเข้ามาใหม่ ชื่อแผน: ' + this.proposal.Project_name + ' (' + this.proposal.Project_code + ')' + '</p> ' +
            '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">ผู้มีอำนาจพิจารณาแผนตั้งงบ</span> โปรดพิจารณาในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.proposal.Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
      }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    },
    SuccessProject(Project) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการปิดโครงการใช่หรือไม่ ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.btnDisable = true
          if (this.Project.IsPlanStatus == '7') {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + Project.Project_code, {
              IsPlanStatus: '8',
              Update_By: this.MeData[0].perid
            }, {
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(res => {
              if (res.data.status) {
                if (Project.Project_type == '1' || (Project.Project_type == '2' && (Project.IsProcess == '1' || Project.IsProcess == '3'))) {
                  this.initApproveMasterByType({
                    type: Project.Project_category
                  }).then(res => {
                    if (res) {
                      if (this.ApproveMaster.length > 0) {
                        var SendMailApprove = this.ApproveMaster.filter(Approveitem => Approveitem.type == Project.Project_category && Approveitem.sendmail == '1' && (Approveitem.Approve_Project_Type_Ms == '1' || Approveitem.Approve_Project_Type_Ms == '9') && Approveitem.readonly == '0' && Approveitem.project_type != '2')
                        if (SendMailApprove.length > 0) {
                          SendMailApprove.map(SendMailI => {
                            this.SendMailSucProject(SendMailI, Project)
                          })
                        }
                      }
                    }
                  })
                }

                this.selProjFiscalYear()
                this.$swal.fire({
                  icon: 'success',
                  title: 'บันทึกข้อมูลสำเร็จ'
                })
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด ไม่สามารถทำรายการได้สำเร็จโปรดติดต่อผู้ดูแลระบบ'
                })
              }
            }).catch(res => {
              if (res) {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด ไม่สามารถทำรายการได้สำเร็จโปรดติดต่อผู้ดูแลระบบ'
                })
              }
            })
          } else {
            this.btnDisable = false
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่สามารถปิดโครงการได้ เนื่องจากยังไม่สิ้นสุดกระบวนการเบิกจ่ายเงินเสร็จสิ้น'
            })
          }
        }
      })
    },
    CancelProject(Project) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการยกเลิกแผนใช่หรือไม่ ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.btnDisable = true
          axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
            queryName: 'updateStatus',
            param: btoa(encodeURIComponent(JSON.stringify({
              id: Project.Project_code,
              status: '9',
              remarks: this.remarksCloseProject,
              Update_By: this.MeData[0].perid
            })))
          }).then(res => {
            if (res.data.status) {
              if (Project.Project_type == '1' || (Project.Project_type == '2' && (Project.IsProcess == '1' || Project.IsProcess == '3'))) {
                this.initApproveMasterByType({
                  type: Project.Project_category
                }).then(res => {
                  if (res) {
                    if (this.ApproveMaster.length > 0) {
                      var SendMailApprove = this.ApproveMaster.filter(Approveitem => Approveitem.type == Project.Project_category && Approveitem.sendmail == '1' && (Approveitem.Approve_Project_Type_Ms == '1' || Approveitem.Approve_Project_Type_Ms == '9') && Approveitem.readonly == '0' && Approveitem.project_type != '2')
                      if (SendMailApprove.length > 0) {
                        SendMailApprove.map(SendMailI => {
                          this.SendMailCancelPlan(SendMailI, Project)
                        })
                      }
                    }
                  }
                })
              }
              this.ProjectObj = null
              this.remarksCloseProject = ""
              this.dialogCancelOrCloseProject = false
              // this.iniPlanAfterAction()
              this.$swal.fire({
                icon: 'success',
                title: 'บันทึกข้อมูลสำเร็จ'
              })
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่สามารถทำรายการได้สำเร็จโปรดติดต่อผู้ดูแลระบบ'
              })
            }
          }).catch(res => {
            if (res) {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่สามารถทำรายการได้สำเร็จโปรดติดต่อผู้ดูแลระบบ'
              })
            }
          })
        }
      })
    },
    SendMailCancelPlan(obj, Project) {
      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
        perid_admin: obj.perid,
        perid: Project.Create_By,
        headerName: 'แจ้งเตือนการการยกเลิกเสนอแผนตั้งงบประมาณประจำปี ' + Project.Project_name + ' (' + Project.Project_code + ')',
        header: Project.Project_name,
        body: '<p style="font-size: 25px;color: peru;font-weight: bold">มีการยกเลิกแผนเสนอขอตั้งงบประมาณประจำปี ชื่อแผน: ' + Project.Project_name + ' (' + Project.Project_code + ')</p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
      }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    },
    SendMailSucProject(obj, Project) {
      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
        perid_admin: obj.perid,
        perid: Project.Create_By,
        headerName: 'แจ้งเตือนการเสร็จสิ้นโครงการจากแผนตั้งงบประมาณประจำปี ' + Project.Project_name + ' (' + Project.Project_code + ')',
        header: Project.Project_name,
        body: '<p style="font-size: 25px;color: peru;font-weight: bold">แผน: ' + Project.Project_name + ' (' + Project.Project_code + ') ณ ขณะนี้ได้เสร็จสิ้นโครงการแล้ว</p> ' +
            '<p style="margin-top: 25px;font-size: 16px;"> <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">สามารถตรวจสอบข้อมูลได้</span> ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/BudgetProject/"> พิจารณาเสนอแผนอนุมัติงบประมาณประจำปี </a> </p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
      }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    },
    selProjFiscalYear() {
      this.dialogLoading = true;
      this.projectDataToTable = []
      this.projectDataToTableDump = []
    this.initProjDataFromFiscalYearUser({
        FiscalYear: this.YearSel,
        permiss_check: this.MeData[0].perid,
        Project_type: this.TypeProject,
      }).then((res) => {
        if (res) {
          if (this.ProjectFromFiscalYearUser.length > 0) {
              this.projectDataToTable = []
              this.ProjectFromFiscalYearUser.map(Project => {
                if (Project.Approve == '1') {
                  this.projectDataToTable.push({
                    ...Project,
                    full_Name: '' +
                        ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                        ' <div><span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span></div>' +
                        ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + (this.depart.filter(depi => depi.dep_id == Project.Dep_Code).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.Dep_Code)[0].dep_name : '') + '</span></div>' +
                        ' <div><span style="font-weight: bold;color: #42b983"> แผน : ' + (Project.IsPlan == '1' ? 'ในแผน' : Project.IsPlan == '0' ? 'นอกแผน' : '-') + '</span></div>' +
                        ' <div><span style="font-weight: bold;color: #42b983"> หมวด : ' + (Project.Project_category == '1' ? 'พัฒนาบุคลากร' : Project.Project_category == '2' ? 'โครงการอื่นๆ' : Project.Project_category == '3' ? 'บริการวิชาการ' : Project.Project_category == '4' ? 'วิจัย' : '-') + '</span></div>' +
                        ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name: '') + '</span></div>' +
                        (Project.IsDataComplete == '0' ? '<p style="font-weight: bold;color: red">****ข้อมูลไม่สมบูรณ์****</p>' : ''),
                    Owner: true
                  })
                }
              })
              this.dialogLoading = false
            this.ChooseYearFiscal()
          } else {
            this.$swal.fire({
              icon: "error",
              title: "ไม่พบข้อมูลโครงการในปีงบประมาณนี้",
            });
          }
          this.ChooseTypeStatus()
        } else {
          this.$swal.fire({
            icon: "error",
            title: "ไม่พบข้อมูลโครงการในปีงบประมาณนี้",
          });
        }
      }).catch((res) => {
        console.log(res);
      }).finally(() => {
        this.dialogLoading = false;
      });
    },
    showHistoryExpenseReal(item) {
      this.expenseDetailRealHistoryData = [];
      this.groupExpenseRealObj = item
      // this.expenseDetailRealHistoryData = item.expense
      // this.dialogShowHistoryExpenseReal = true;
      axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
        queryName: 'getExpenseRealProject',
        param: btoa(encodeURIComponent(JSON.stringify({
          id: this.Project_code,
          permiss_check: this.MeData[0].perid,
        })))
      }).then(res => {
        if (res.data.length > 0) {
          this.expenseDetailRealHistoryData = res.data.filter(itemEx => itemEx.Id_inp == item.Id_inp).length > 0 ? res.data.filter(itemEx => itemEx.Id_inp == item.Id_inp)[0].ExpenseDetail : [];
          this.dialogShowHistoryExpenseReal = true;
        } else {
          this.$swal.fire({
            icon: "error",
            title: "ไม่พบข้อมูลการเบิกจ่ายเงิน",
          });
        }
      }).catch(err => {
        console.log(err);
        this.$swal.fire({
          icon: "error",
          title: "ไม่สามารถดึงข้อมูลการเบิกจ่ายเงินได้",
        });
      });
    },
    showExpenseReal(item) {
      this.expenseRealHistoryData = [];
      this.ExpenseRealObj = item
      this.expenseRealHistoryData = item.expense
      this.dialogShowExpenseReal = true;
    },
    showRemarksCancelProj(item) {
      this.dialogLoading = false;
      this.RemarksCancelProj = ''
      this.getCancelRemarksProj({
          permiss_check: this.MeData[0].perid,
          Project_code: item.Project_code,
        }).then((res) => {
          if (res) {
            if (this.cancelProjRemarks.length > 0) {
              this.RemarksCancelProj = this.cancelProjRemarks[0].Remarks == null ? '' : this.cancelProjRemarks[0].Remarks
            } else {
              this.RemarksCancelProj = ''
            }
          }
        }).catch((res) => {
          console.log(res);
          this.$swal.fire({
            icon: "error",
            title: "ไม่สามารถดึงข้อมูลหมายเหตุการยกเลิกโครงการได้",
          });
        }).finally(() => {
          this.dialogLoading = false;
        });
      this.dialogShowCencelRemarks = true
    },
    OpenDialogReport() {
      this.exportType = null
      this.exportType2 = null
      this.exportType4 = null
      this.dialogExportPlanProj = true
    },
    ExportData() {
      if (this.exportType != null && this.exportType2 != null && this.exportType4 != null && this.exportDepGroup != null) {
        if ((this.exportType4 == '2' || this.exportType4 == '0') && (this.exportType3 === null || this.exportType3 === undefined)) {
          this.$swal.fire({
            icon: 'error',
            title: 'กรุณาเลือกข้อมูลให้ครบถ้วน!',
          })
          return
        }
        this.json_data = []
        var count = 0
        if (this.projectDataToTableDump.length > 0) {
            // Prepare department filter
            let depIds = [];
            if (this.exportDepGroup !== 'all') {
            depIds = this.depart
              .filter(dep => dep.dep_group_id === this.exportDepGroup)
              .map(dep => dep.dep_id);
            }

            // Filter projects
            let filteredProjects = this.projectDataToTableDump.filter(item =>
            item.Approve == '1' &&
            item.FiscalYear == this.YearSel &&
            item.Project_category == this.exportType &&
            item.Project_type == this.exportType2 &&
            (
              this.exportDepGroup === 'all'
              ? true
              : depIds.includes(item.Dep_Code)
            )
            );

            if (filteredProjects.length > 0) {
              // ป้องกัน Project_code ซ้ำ และแปลง Create_Time เป็นวันที่ภาษาไทย
              const seenProjectCodes = new Set();
              filteredProjects.map((item) => {
                // คำนวณ DateStart และ DateEnd ตาม episode ของแต่ละ item
                let DateStart = '';
                let DateEnd = '';
                switch (item.DatePeriod) {
                  case '1':
                  DateStart = (parseInt(item.FiscalYear) - 1) + '-10-01';
                  DateEnd = (parseInt(item.FiscalYear) - 1) + '-12-31';
                  break;
                  case '2':
                  DateStart = item.FiscalYear + '-01-01';
                  DateEnd = item.FiscalYear + '-03-31';
                  break;
                  case '3':
                  DateStart = item.FiscalYear + '-04-01';
                  DateEnd = item.FiscalYear + '-06-30';
                  break;
                  case '4':
                  DateStart = item.FiscalYear + '-07-01';
                  DateEnd = item.FiscalYear + '-09-30';
                  break;
                  case '9':
                  DateStart = (parseInt(item.FiscalYear) - 1) + '-10-01';
                  DateEnd = item.FiscalYear + '-09-30';
                  break;
                  default:
                  DateStart = (parseInt(item.FiscalYear) - 1) + '-10-01';
                  DateEnd = item.FiscalYear + '-09-30';
                  break;
                }
                // สร้าง Project_date ตามช่วง DatePeriod
                let Project_date = '';
                switch (item.DatePeriod) {
                  case '1':
                  Project_date = 'ต.ค. ' + (parseInt(item.FiscalYear) + 543 - 1) + '- ธ.ค. ' + (parseInt(item.FiscalYear) + 543 - 1);
                  break;
                  case '2':
                  Project_date = 'ม.ค. ' + (parseInt(item.FiscalYear) + 543) + '- มี.ค. ' + (parseInt(item.FiscalYear) + 543);
                  break;
                  case '3':
                  Project_date = 'เม.ย. ' + (parseInt(item.FiscalYear) + 543) + '- มิ.ย. ' + (parseInt(item.FiscalYear) + 543);
                  break;
                  case '4':
                  Project_date = 'ก.ค. ' + (parseInt(item.FiscalYear) + 543) + '- ก.ย. ' + (parseInt(item.FiscalYear) + 543);
                  break;
                  case '9':
                  Project_date = 'ตลอดปีงบประมาณ ' + (parseInt(item.FiscalYear) + 543);
                  break;
                  default:
                  Project_date = '';
                }

                function formatThaiDate(dateStr) {
                  if (!dateStr) return '';
                  const months = [
                  '', 'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.',
                  'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'
                  ];
                  const d = new Date(dateStr);
                  if (isNaN(d)) return '';
                  const day = d.getDate();
                  const month = months[d.getMonth() + 1];
                  const year = d.getFullYear() + 543;
                  const hour = d.getHours().toString().padStart(2, '0');
                  const min = d.getMinutes().toString().padStart(2, '0');
                  const sec = d.getSeconds().toString().padStart(2, '0');
                  return `${day} ${month} ${year} ${hour}:${min}:${sec}`;
                }

                if (!seenProjectCodes.has(item.Project_code)) {
                  seenProjectCodes.add(item.Project_code);

                  const Create_Time_Thai = formatThaiDate(item.Create_Time);

                    if (
                      this.exportType4 == '0' &&
                      (item.IsPlanStatus == '2' || item.IsPlanStatus == '6' || item.IsPlanStatus == '7' || item.IsPlanStatus == '8')
                    ) {
                      const money = parseFloat(item.MoneyDisburse || 0)
                      const type3 = this.exportType3 // '9' = ทั้งหมด, '0' = MoneyDisburse == 0, '1' = MoneyDisburse > 0
                      const include =
                        type3 === '9' ||
                        (type3 === '0' && money === 0) ||
                        (type3 === '1' && money > 0)

                      if (include) {
                        this.json_data.push({
                          ...item,
                          index: ++count,
                          PLACE: this.PLACESelete.filter(itemP => itemP.id == item.PLACE).length > 0 ? this.PLACESelete.filter(itemP => itemP.id == item.PLACE)[0].detail : '',
                          WorkBy: this.WorkByData.filter(itemW => itemW.id == item.WorkBy).length > 0 ? this.WorkByData.filter(itemW => itemW.id == item.WorkBy)[0].detail : '',
                          Dep_Name: this.depart.filter(itemD => itemD.dep_id == item.Dep_Code).length > 0 ? this.depart.filter(itemD => itemD.dep_id == item.Dep_Code)[0].dep_name : '',
                          FiscalYear2: parseInt(item.FiscalYear) + 543,
                          DateStart,
                          DateEnd,
                          Project_date,
                          Create_Time: Create_Time_Thai
                        });
                      }
                    } else if (
                      this.exportType4 == '2' &&
                      (item.IsPlanStatus == '6' || item.IsPlanStatus == '7' || item.IsPlanStatus == '8')
                      ) {
                      const money = parseFloat(item.MoneyDisburse || 0)
                      const type3 = this.exportType3 // '9' = ทั้งหมด, '0' = MoneyDisburse == 0, '1' = MoneyDisburse > 0
                      const include =
                        type3 === '9' ||
                        (type3 === '0' && money === 0) ||
                        (type3 === '1' && money > 0)

                      if (include) {
                        this.json_data.push({
                        ...item,
                        index: ++count,
                        PLACE: this.PLACESelete.filter(itemP => itemP.id == item.PLACE).length > 0 ? this.PLACESelete.filter(itemP => itemP.id == item.PLACE)[0].detail : '',
                        WorkBy: this.WorkByData.filter(itemW => itemW.id == item.WorkBy).length > 0 ? this.WorkByData.filter(itemW => itemW.id == item.WorkBy)[0].detail : '',
                        Dep_Name: this.depart.filter(itemD => itemD.dep_id == item.Dep_Code).length > 0 ? this.depart.filter(itemD => itemD.dep_id == item.Dep_Code)[0].dep_name : '',
                        FiscalYear2: parseInt(item.FiscalYear) + 543,
                        DateStart,
                        DateEnd,
                        Project_date,
                        Create_Time: Create_Time_Thai
                        })
                      }
                  } else if (this.exportType4 == '1') {
                    this.json_data.push({
                      ...item,
                      index: ++count,
                      PLACE: this.PLACESelete.filter(itemP => itemP.id == item.PLACE).length > 0 ? this.PLACESelete.filter(itemP => itemP.id == item.PLACE)[0].detail : '',
                      WorkBy: this.WorkByData.filter(itemW => itemW.id == item.WorkBy).length > 0 ? this.WorkByData.filter(itemW => itemW.id == item.WorkBy)[0].detail : '',
                      Dep_Name: this.depart.filter(itemD => itemD.dep_id == item.Dep_Code).length > 0 ? this.depart.filter(itemD => itemD.dep_id == item.Dep_Code)[0].dep_name : '',
                      FiscalYear2: parseInt(item.FiscalYear) + 543,
                      DateStart,
                      DateEnd,
                      Project_date,
                      Create_Time: Create_Time_Thai
                    });
                  }
                }
              })
            } else {
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่พบข้อมูลที่ต้องการ Export'
            })
            }
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุข้อมูลให้ครบถ้วน'
        })
      }
    },
  },
  mounted() {
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreSubMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '6',
          page_sub_id: '1',
        })
        this.getSubMenuPermissData().then(res => {
          if (res) {
            if (this.SubMenuPermiss.length > 0 && this.SubMenuPermiss.filter(item => item.page_sub_id == '1' && item.PageStatus_page_id == '6' && item.page_status == '1').length > 0 || this.IgnoreSubMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
              this.getPermissionData({
                perid: this.MeData[0].perid
              }).then(resAdmin => {
                if (resAdmin) {
                  this.PermissionAdmin.map((Per_i, idx) => {
                    if (Per_i.permission_id == '10000') {
                      this.CheckAdmin = true
                      this.init()
                    } else {
                      if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                        this.$router.push('/')
                      }
                    }
                  })
                } else {
                  this.getPermissionUserData({
                    perid: this.MeData[0].perid
                  }).then(resUser => {
                    if (resUser) {
                      this.Permission.map((Per_i, idx) => {
                        if (Per_i.permission_id == '10000') {
                          this.CheckSubAdmin = true
                          this.init()
                        } else {
                          if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                            this.$router.push('/')
                          }
                        }
                      })
                    } else {
                      this.CheckSubAdmin = false
                      this.CheckAdmin = false
                      this.$router.push('/')
                    }
                  })
                }
              })
            } else {
              this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '1' && item.PageStatus_page_id == '6' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '1' && item.PageStatus_page_id == '6')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
              this.maintain = true
            }
          }
        }).then(err => {
          if (err) {
            this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '1' && item.PageStatus_page_id == '6' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '1' && item.PageStatus_page_id == '6')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
            this.maintain = true
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>
